import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "table-editor-container app-page app-page--fill" }
const _hoisted_2 = { class: "list-header" }
const _hoisted_3 = { class: "table-list-wrapper" }
const _hoisted_4 = { class: "right-panel" }
const _hoisted_5 = {
  key: 0,
  class: "edit-area",
  "element-loading-text": "加载中..."
}
const _hoisted_6 = { class: "edit-mode-control" }
const _hoisted_7 = { class: "table-name-section" }
const _hoisted_8 = { class: "form-control" }
const _hoisted_9 = {
  key: 0,
  class: "form-error-text"
}
const _hoisted_10 = { class: "form-control" }
const _hoisted_11 = {
  key: 0,
  class: "form-error-text"
}
const _hoisted_12 = { class: "form-control" }
const _hoisted_13 = {
  key: 0,
  class: "form-error-text"
}
const _hoisted_14 = { class: "form-control" }
const _hoisted_15 = {
  key: 0,
  class: "form-error-text"
}
const _hoisted_16 = { class: "form-item" }
const _hoisted_17 = { class: "form-item" }
const _hoisted_18 = { class: "form-item" }
const _hoisted_19 = { class: "form-item" }
const _hoisted_20 = { class: "form-item" }
const _hoisted_21 = { class: "form-item form-item--remark" }
const _hoisted_22 = { class: "attributes-container" }
const _hoisted_23 = { class: "special-attributes" }
const _hoisted_24 = { class: "attributes-columns" }
const _hoisted_25 = { class: "attributes-column global-attributes" }
const _hoisted_26 = { class: "column-title" }
const _hoisted_27 = { class: "attributes-list" }
const _hoisted_28 = ["draggable", "onDragstart", "onDragover", "onDrop"]
const _hoisted_29 = {
  key: 0,
  class: "drag-handle",
  title: "拖拽排序"
}
const _hoisted_30 = {
  key: 1,
  class: "attribute-options-display"
}
const _hoisted_31 = { class: "attributes-column single-attributes" }
const _hoisted_32 = { class: "column-title" }
const _hoisted_33 = { class: "attributes-list" }
const _hoisted_34 = ["draggable", "onDragstart", "onDragover", "onDrop"]
const _hoisted_35 = {
  key: 0,
  class: "drag-handle",
  title: "拖拽排序"
}
const _hoisted_36 = {
  key: 1,
  class: "attribute-options-display"
}
const _hoisted_37 = { class: "image-upload-section" }
const _hoisted_38 = {
  key: 0,
  class: "upload-progress-container"
}
const _hoisted_39 = { class: "progress-text" }
const _hoisted_40 = {
  key: 2,
  class: "uploaded-file-item",
  style: {"margin-top":"10px","display":"flex","align-items":"center","justify-content":"space-between","padding":"10px","background":"#f5f7fa","border-radius":"4px","border":"1px solid #e4e7ed"}
}
const _hoisted_41 = {
  class: "file-thumbnail-wrapper",
  style: {"position":"relative","width":"40px","height":"40px","display":"flex","align-items":"center","justify-content":"center","margin-right":"8px","border":"1px solid #e4e7ed","border-radius":"4px","overflow":"hidden","background-color":"#f5f7fa"}
}
const _hoisted_42 = ["src"]
const _hoisted_43 = ["title"]
const _hoisted_44 = {
  key: 0,
  class: "toolbar"
}
const _hoisted_45 = {
  key: 0,
  class: "toolbar-left"
}
const _hoisted_46 = { class: "toolbar-right" }
const _hoisted_47 = {
  key: 1,
  class: "table-container"
}
const _hoisted_48 = { class: "table-wrapper" }
const _hoisted_49 = ["title"]
const _hoisted_50 = ["title"]
const _hoisted_51 = ["onClick", "onContextmenu"]
const _hoisted_52 = { class: "vertical-header-cell" }
const _hoisted_53 = {
  key: 0,
  class: "row-control"
}
const _hoisted_54 = {
  key: 1,
  class: "row-control"
}
const _hoisted_55 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_56 = { class: "column-type-options" }
const _hoisted_57 = ["onClick"]
const _hoisted_58 = { class: "type-icon" }
const _hoisted_59 = { class: "type-label" }
const _hoisted_60 = { class: "auto-fill-row-setting" }
const _hoisted_61 = { class: "select-options-editor" }
const _hoisted_62 = {
  key: 0,
  class: "preset-value-tip"
}
const _hoisted_63 = { class: "options-list" }
const _hoisted_64 = { class: "option-main" }
const _hoisted_65 = {
  key: 0,
  class: "option-image-preview"
}
const _hoisted_66 = ["onClick"]
const _hoisted_67 = ["src"]
const _hoisted_68 = { class: "option-image-info" }
const _hoisted_69 = ["title"]
const _hoisted_70 = { class: "select-option-image-preview-dialog" }
const _hoisted_71 = ["src"]
const _hoisted_72 = {
  key: 1,
  class: "preview-loading"
}

import { ref, computed, watch, nextTick, onMounted, onUnmounted, onActivated } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { Plus, Delete, Edit, Close, Setting, UploadFilled, Document, Refresh, DataAnalysis, CircleCheck, ArrowDown, Check, Printer, Rank, CollectionTag, Collection, DocumentCopy, CopyDocument } from '@element-plus/icons-vue';
import { ElMessage, ElMessageBox, UploadProps, UploadUserFile, genFileId, UploadInstance } from 'element-plus';
import DynamicTable from '@/components/DynamicTable.vue';
import { ParameterSettings } from '@/network/index';
import type { ColumnType, TableData } from './types';
import { parseTableDetail, formatTableDataForSave, createDefaultTableData } from './utils';
import { usePageStateStore } from '@/store/pageStateStore';
import { useDetailStore } from '@/store/detailStore';
import { getMenuChildPathByComponent } from '@/utils/menuRoute';
import { useButtonPermission } from '@/utils/buttonPermission';

const DEFAULT_DEVICE_TYPE = '单个数据读数设备';

const minPanelWidth = 200;

// 表格容器和列头引用（用于计算分区名称位置）
const SELECT_OPTION_IMAGE_SEPARATOR = '|||';
interface AttrWithId {
  id: string;
  originalIndex: number;
  title: string;
  options: string[];
  isSingle?: boolean;
}

// 全局属性列表（isSingle 为 false/缺省，左侧区域渲染）

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { can } = useButtonPermission('/ParameterSettings/tableEditing/index.vue');

const router = useRouter();
const route = useRoute();
const pageStateStore = usePageStateStore();
const detailStore = useDetailStore();
const activeTableIndex = ref<number>(-1);
// tableList 存储接口返回的原始数据（用于左侧列表展示）
const tableList = ref<any[]>([]);
// model数据，用于表格表头展示
const tableModel = ref<Record<string, string> | undefined>(undefined);
// currentTable 存储当前编辑的表格数据（完整的 TableData 结构）
const currentTable = ref<TableData | null>(null);
const showNameError = ref(false);
const showControlNumberError = ref(false);
const showNumberSuffixError = ref(false);
const showImplementDateError = ref(false);
const suppressTableListAutoSelect = ref(false);
const deviceTypeLoading = ref(false);
const deviceTypeOptions = ref<Array<{ 名称: string; 提示词?: string; Id: string | number }>>([]);
const getDefaultDeviceType = () => {
  const matched = deviceTypeOptions.value.find(item => item.名称 === DEFAULT_DEVICE_TYPE);
  return matched?.名称 || DEFAULT_DEVICE_TYPE;
};

// 左侧面板拖拽调整宽度相关
const mainContentRef = ref<HTMLElement | null>(null);
const leftPanelRef = ref<HTMLElement | null>(null);
const leftPanelWidth = ref<number>(300);
const isResizing = ref<boolean>(false);
const editableTableRef = ref<HTMLTableElement | null>(null);
const cornerHeaderRef = ref<HTMLElement | null>(null);
const columnHeaderRefs = ref<Map<number, HTMLElement>>(new Map());

// 设置列头引用
const setColumnHeaderRef = (el: HTMLElement | null, colIndex: number) => {
  if (el) {
    columnHeaderRefs.value.set(colIndex, el);
  } else {
    columnHeaderRefs.value.delete(colIndex);
  }
};

// 计算分区名称的位置样式（相对于 table-wrapper）
// columnBorders[colIndex] 表示第 colIndex 列与第 colIndex+1 列之间的分界线
// sectionNames[colIndex] 是分界线右侧的分区名称
const getSectionNameStyle = (colIndex: number) => {
  const tableEl = editableTableRef.value;
  if (!tableEl) {
    return { display: 'none' };
  }

  const tableRect = tableEl.getBoundingClientRect();
  
  // 分区名称显示在第 colIndex 列的右边界
  const headerEl = columnHeaderRefs.value.get(colIndex);
  if (!headerEl) {
    return { display: 'none' };
  }
  const headerRect = headerEl.getBoundingClientRect();
  const left = headerRect.right - tableRect.left + 8;

  return {
    left: `${left}px`,
    transform: 'translateX(0)'
  };
};

// 计算第一分区名称的位置样式（显示在标题列右边界，即第一列左边）
const getFirstSectionNameStyle = () => {
  const tableEl = editableTableRef.value;
  const cornerEl = cornerHeaderRef.value;
  if (!tableEl || !cornerEl) {
    return { display: 'none' };
  }

  const tableRect = tableEl.getBoundingClientRect();
  const cornerRect = cornerEl.getBoundingClientRect();
  const left = cornerRect.right - tableRect.left + 8;

  return {
    left: `${left}px`,
    transform: 'translateX(0)'
  };
};

// 分区名称位置更新触发器
const sectionNameKey = ref(0);

// 强制更新分区名称位置
const updateSectionNames = () => {
  sectionNameKey.value++;
};

// 监听 currentTable 变化，延迟更新分区名称位置
watch(
  () => currentTable.value,
  () => {
    // 等待 DOM 更新后重新计算位置
    nextTick(() => {
      setTimeout(updateSectionNames, 100);
    });
  },
  { deep: true }
);

watch(() => currentTable.value, () => {
  showNameError.value = false;
  showControlNumberError.value = false;
  showNumberSuffixError.value = false;
  showImplementDateError.value = false;
});

const startResize = (e: MouseEvent) => {
  isResizing.value = true;
  document.addEventListener('mousemove', handleResize);
  document.addEventListener('mouseup', stopResize);
  document.body.style.cursor = 'col-resize';
  document.body.style.userSelect = 'none';
};

const handleResize = (e: MouseEvent) => {
  if (!isResizing.value || !mainContentRef.value) return;
  const containerRect = mainContentRef.value.getBoundingClientRect();
  const maxWidth = containerRect.width / 2;
  let newWidth = e.clientX - containerRect.left;
  newWidth = Math.max(minPanelWidth, Math.min(maxWidth, newWidth));
  leftPanelWidth.value = newWidth;
};

const stopResize = () => {
  isResizing.value = false;
  document.removeEventListener('mousemove', handleResize);
  document.removeEventListener('mouseup', stopResize);
  document.body.style.cursor = '';
  document.body.style.userSelect = '';
};

onUnmounted(() => {
  document.removeEventListener('mousemove', handleResize);
  document.removeEventListener('mouseup', stopResize);
});

// 加载状态
const loading = ref<boolean>(false); // 右侧详情区域加载状态
const listLoading = ref<boolean>(false); // 左侧列表加载状态

// 筛选参数
const filterParams = ref<any[]>([]);

// 分页配置
const pagination = ref({
  show: true,
  page: 1,
  pageSize: 10,
  total: 0,
  pageSizes: [10, 20, 50, 100],

  layout: 'total, sizes, prev, pager, next',
  small: true
});

// 编辑模式控制
const isEditMode = ref<boolean>(false);

// 列类型设置相关
const showColumnTypeDialog = ref(false);
const editingColumnIndex = ref<number>(-1);
const editingAutoFillRows = ref(0);
const columnTypeOptions = [
  { label: '文本输入框', value: 'text' },
  { label: '数字输入框', value: 'number' },
  { label: '单选框', value: 'radio' },
  { label: '下拉选择框', value: 'select' },
  { label: '表格预设值列', value: 'preset' }
] as const;

// 辅助函数：创建默认表格数据
const createEmptyTable = (name?: string): TableData => createDefaultTableData(name);

const clearRequiredFieldErrors = () => {
  showNameError.value = false;
  showControlNumberError.value = false;
  showNumberSuffixError.value = false;
  showImplementDateError.value = false;
};

const validateRequiredFields = () => {
  if (!currentTable.value) return false;
  showNameError.value = !String(currentTable.value.name || '').trim();
  showControlNumberError.value = !String(currentTable.value.controlNumber || '').trim();
  showNumberSuffixError.value = !String(currentTable.value.numberSuffix || '').trim();
  showImplementDateError.value = !currentTable.value.implementDate;
  return !showNameError.value
    && !showControlNumberError.value
    && !showNumberSuffixError.value
    && !showImplementDateError.value;
};

// 辅助函数：查找表格列表中的项索引
const findTableIndex = (row: any): number => {
  return tableList.value.findIndex((item: any) => {
    if (row.Id !== undefined && item.Id !== undefined) return item.Id === row.Id;
    if (row.id !== undefined && item.id !== undefined) return item.id === row.id;
    return item === row;
  });
};

// 辅助函数：查找表格列表中的项（优先通过ID匹配，ID不存在时才用名称匹配）
const findTableItem = (targetId?: number | string, targetName?: string): any => {
  // 优先通过ID精确匹配
  if (targetId) {
    const targetIdText = String(targetId);
    const foundById = tableList.value.find((item: any) => 
      String(item.Id ?? item.id ?? '') === targetIdText
    );
    if (foundById) return foundById;
  }
  // ID匹配失败时，才通过名称匹配
  if (targetName) {
    return tableList.value.find((item: any) => item.名称 === targetName || item.name === targetName);
  }
  return null;
};

// 下拉选项编辑相关
const showSelectOptionsDialog = ref(false);
const editingSelectOptionsColumnIndex = ref<number>(-1);
const editingSelectOptions = ref<string[]>([]);
const selectOptionImageMeta = ref<Record<number, {
  uploading?: boolean;
  loading?: boolean;
  thumbnailUrl?: string;
}>>({});
const selectOptionImagePreviewVisible = ref(false);
const selectOptionPreviewUrl = ref('');
const isPresetValueColumn = computed(() => {
  const columnIndex = editingSelectOptionsColumnIndex.value;
  return columnIndex >= 0 && currentTable.value?.columnTypes[columnIndex] === 'preset';
});
const canUploadSelectOptionImage = computed(() => (
  !isPresetValueColumn.value && editingSelectOptionsColumnIndex.value === 0
));
const selectOptionsDialogTitle = computed(() => (
  isPresetValueColumn.value
    ? '编辑表格预设值'
    : (canUploadSelectOptionImage.value ? '编辑下拉选项（第一列可绑定图片）' : '编辑下拉选项（仅文字）')
));

const autoFillRowOptions = computed(() => {
  const rowCount = currentTable.value?.verticalHeaders.length || 1;
  return Array.from({ length: rowCount }, (_, index) => index + 1);
});

const syncPresetColumn = (colIndex: number) => {
  if (!currentTable.value || currentTable.value.columnTypes[colIndex] !== 'preset') return;

  const rowCount = currentTable.value.verticalHeaders.length;
  const previousValues = currentTable.value.selectOptions[colIndex] || [];
  const values = Array.from({ length: rowCount }, (_, rowIndex) => (
    String(previousValues[rowIndex] || '')
  ));

  currentTable.value.selectOptions[colIndex] = values;
  currentTable.value.data.forEach((row, rowIndex) => {
    row[colIndex] = values[rowIndex] || '';
  });
};

const updateEditingAutoFillRows = (value: string | number) => {
  if (!currentTable.value || editingColumnIndex.value < 0) return;
  if (!currentTable.value.autoFillRowCounts) currentTable.value.autoFillRowCounts = [];
  currentTable.value.autoFillRowCounts[editingColumnIndex.value] = Math.max(0, Number(value) || 0);
};

const isAutoFillGroupStart = (rowIndex: number, colIndex: number) => {
  if (!currentTable.value || rowIndex <= 0) return false;
  const fillRows = Number(currentTable.value.autoFillRowCounts[colIndex]) || 0;
  return fillRows > 1 && rowIndex % fillRows === 0;
};

// 图片上传相关
const imageUploadRef = ref<UploadInstance>();
const imageFileList = ref<UploadUserFile[]>([]);
const imageUploading = ref<boolean>(false); // 图片上传中状态
const uploadProgress = ref<number>(0); // 上传进度百分比
// 添加用于存储缩略图URL的Map
const thumbnailCache = new Map<string, string>(); // key: serverCode, value: thumbnail URL

const splitSelectOptionValue = (value: string) => {
  const [text = '', imageCode = ''] = String(value || '').split(SELECT_OPTION_IMAGE_SEPARATOR);
  return {
    text: text.trim(),
    imageCode: imageCode.trim()
  };
};

const buildSelectOptionValue = (text: string, imageCode?: string) => {
  const optionText = text.trim();
  const optionImageCode = String(imageCode || '').trim();
  return optionImageCode ? `${optionText}${SELECT_OPTION_IMAGE_SEPARATOR}${optionImageCode}` : optionText;
};

const getSelectOptionText = (value: string) => splitSelectOptionValue(value).text;

const getSelectOptionImageCode = (value: string) => splitSelectOptionValue(value).imageCode;

const stripSelectOptionImages = (options: string[]) => {
  return options.map((option, index) => getSelectOptionText(option) || `选项${index + 1}`);
};

const normalizeSelectOptionImages = (table: TableData) => {
  table.selectOptions = table.selectOptions.map((options, colIndex) => (
    colIndex === 0 ? options : stripSelectOptionImages(options || [])
  ));
};

// 获取图片内容（用于缩略图和预览）
const fetchImageContent = async (serverCode: string): Promise<string | null> => {
  if (!serverCode) return null;
  
  // Check cache first
  if (thumbnailCache.has(serverCode)) {
    return thumbnailCache.get(serverCode)!;
  }

  try {
    const res: any = await ParameterSettings.parameterSettingsDownload({ fileName: serverCode });
    let imageUrl = '';
    
    if (res instanceof Blob) {
      imageUrl = URL.createObjectURL(res);
    } else {
      // 尝试从不同结构中获取数据
      const data = res?.response || res?.data || res;
      
      if (data instanceof Blob) {
        imageUrl = URL.createObjectURL(data);
      } else if (typeof data === 'string') {
        if (data.startsWith('http') || data.startsWith('blob:') || data.startsWith('data:')) {
          imageUrl = data;
        } else {
          imageUrl = `data:image/jpeg;base64,${data}`;
        }
      }
    }

    if (imageUrl) {
      thumbnailCache.set(serverCode, imageUrl);
      return imageUrl;
    }
  } catch (e) {
    console.warn(`图片加载失败 (${serverCode}):`, e);
  }
  return null;
};

const setSelectOptionImageMeta = (index: number, meta: Partial<{
  uploading: boolean;
  loading: boolean;
  thumbnailUrl: string;
}>) => {
  selectOptionImageMeta.value = {
    ...selectOptionImageMeta.value,
    [index]: {
      ...(selectOptionImageMeta.value[index] || {}),
      ...meta
    }
  };
};

const loadSelectOptionThumbnail = async (index: number) => {
  const imageCode = getSelectOptionImageCode(editingSelectOptions.value[index] || '');
  if (!imageCode) {
    setSelectOptionImageMeta(index, { loading: false, thumbnailUrl: '' });
    return;
  }

  setSelectOptionImageMeta(index, { loading: true });
  try {
    const url = await fetchImageContent(imageCode);
    setSelectOptionImageMeta(index, { loading: false, thumbnailUrl: url || '' });
  } catch (error) {
    console.warn('加载选项图片缩略图失败:', error);
    setSelectOptionImageMeta(index, { loading: false, thumbnailUrl: '' });
  }
};

const refreshSelectOptionThumbnails = () => {
  selectOptionImageMeta.value = {};
  editingSelectOptions.value.forEach((option, index) => {
    if (getSelectOptionImageCode(option)) {
      loadSelectOptionThumbnail(index);
    }
  });
};

const handleSelectOptionImageUpload = async (options: any, index: number) => {
  if (!canUploadSelectOptionImage.value) {
    ElMessage.warning('仅第一列选项可上传图片');
    return;
  }
  const file = options.file;
  if (!file) return;

  setSelectOptionImageMeta(index, { uploading: true });
  try {
    const form = new FormData();
    form.append('image', file, file.name || 'upload.jpg');

    const res = await ParameterSettings.parameterSettingsUploadWithProgress(form);
    if (res && res.success) {
      const imageCode = String(res.response || res.data || file.name || '').trim();
      if (!imageCode) {
        ElMessage.error('上传成功但未返回图片名称');
        return;
      }

      const currentText = getSelectOptionText(editingSelectOptions.value[index] || '') || `选项${index + 1}`;
      editingSelectOptions.value[index] = buildSelectOptionValue(currentText, imageCode);
      await loadSelectOptionThumbnail(index);
      ElMessage.success('选项图片绑定成功');
    } else {
      ElMessage.error('选项图片上传失败');
    }
  } catch (error) {
    console.error('选项图片上传失败:', error);
    ElMessage.error('选项图片上传失败');
  } finally {
    setSelectOptionImageMeta(index, { uploading: false });
  }
};

const clearSelectOptionImage = (index: number) => {
  if (!canUploadSelectOptionImage.value) return;
  const optionText = getSelectOptionText(editingSelectOptions.value[index] || '');
  editingSelectOptions.value[index] = optionText;
  setSelectOptionImageMeta(index, { loading: false, uploading: false, thumbnailUrl: '' });
};

const previewSelectOptionImage = async (index: number) => {
  if (!canUploadSelectOptionImage.value) return;
  const imageCode = getSelectOptionImageCode(editingSelectOptions.value[index] || '');
  if (!imageCode) return;

  const cachedUrl = selectOptionImageMeta.value[index]?.thumbnailUrl;
  if (cachedUrl) {
    selectOptionPreviewUrl.value = cachedUrl;
    selectOptionImagePreviewVisible.value = true;
    return;
  }

  selectOptionPreviewUrl.value = '';
  selectOptionImagePreviewVisible.value = true;
  const url = await fetchImageContent(imageCode);
  if (url) {
    selectOptionPreviewUrl.value = url;
    setSelectOptionImageMeta(index, { thumbnailUrl: url });
  } else {
    selectOptionImagePreviewVisible.value = false;
    ElMessage.error('选项图片预览失败');
  }
};

// 监听图片代码变化
watch(() => currentTable.value?.imageCode, async (newCode) => {
  if (newCode) {
    const fileObj: any = {
      name: currentTable.value?.imageName || '示意图.jpg',
      url: '', 
      uid: -1,
      status: 'success',
      serverCode: newCode,
      loading: true
    };
    imageFileList.value = [fileObj];
    
    // 异步获取图片用于缩略图
    fetchImageContent(newCode).then(url => {
      if (url) {
        fileObj.url = url;
      }
      fileObj.loading = false;
      // 强制触发响应式更新
      imageFileList.value = [{ ...fileObj }];
    }).catch(() => {
      fileObj.loading = false;
      imageFileList.value = [{ ...fileObj }];
    });
  } else {
    imageFileList.value = [];
  }
}, { immediate: true });

const handleImageUpload = async (options: any) => {
  imageUploading.value = true; // 开始上传
  uploadProgress.value = 0; // 重置进度
  try {
    const form = new FormData();
    form.append('image', options.file);
    
    // 使用带进度监听的上传
    const res = await ParameterSettings.parameterSettingsUploadWithProgress(form, (progress: number) => {
      uploadProgress.value = progress;
    });
    
    if (res && res.success) {
        const code = res.response || res.data;
        if (currentTable.value) {
            currentTable.value.imageCode = code;
            currentTable.value.imageName = options.file.name;
        }
        
        const fileObj: any = {
            name: options.file.name,
            uid: options.file.uid,
            status: 'success',
            serverCode: code,
            url: '',
            loading: true
        };
        imageFileList.value = [fileObj];
        
        // 立即获取图片用于缩略图
        fetchImageContent(code).then(url => {
          if (url) {
            fileObj.url = url;
          }
          fileObj.loading = false;
          // 强制触发响应式更新
          imageFileList.value = [{ ...fileObj }];
        }).catch(() => {
          fileObj.loading = false;
          imageFileList.value = [{ ...fileObj }];
        });
        
        ElMessage.success('上传成功');
    } else {
        ElMessage.error('上传失败');
        imageFileList.value = [];
    }
  } catch (e) {
    console.error(e);
    ElMessage.error('上传失败');
    imageFileList.value = [];
  } finally {
    imageUploading.value = false; // 上传结束
    uploadProgress.value = 0; // 重置进度
  }
};

const handleImageRemove = async () => {
  if (currentTable.value?.imageCode) {
    try {
      await ElMessageBox.confirm('确定要删除这张图片吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      });

      const res = await ParameterSettings.parameterSettingsDeleteImage({ 
        fileName: currentTable.value.imageCode 
      });

      if (res && res.success) {
        if (currentTable.value) {
          currentTable.value.imageCode = '';
          currentTable.value.imageName = '';
        }
        imageFileList.value = [];
        ElMessage.success('图片删除成功');
      } else {
        ElMessage.error(res?.msg || '图片删除失败');
      }
    } catch (error) {
      if (error !== 'cancel') {
        console.error(error);
        ElMessage.error('图片删除失败');
      }
    }
  } else {
    // 如果没有服务器端代码（仅本地状态），直接清除
    if (currentTable.value) {
      currentTable.value.imageCode = '';
      currentTable.value.imageName = '';
    }
    imageFileList.value = [];
  }
};

const handleExceed: UploadProps['onExceed'] = () => {
  ElMessage.warning('请先删除现有图片后再上传新图片');
};

const previewImage = async (file: UploadUserFile) => {
  try {
    // 如果已有url，直接使用
    if ((file as any).url) {
      window.open((file as any).url, '_blank');
      return;
    }
    
    const serverCode = (file as any).serverCode || currentTable.value?.imageCode;
    if (serverCode) {
      const url = await fetchImageContent(serverCode);
      if (url) {
        // 更新文件的url属性，下次直接使用
        (file as any).url = url;
        window.open(url, '_blank');
      } else {
        ElMessage.error('预览失败');
      }
    }
  } catch(e) {
    console.error('预览失败:', e);
    ElMessage.error('预览失败');
  }
};

// 计算当前列类型
const currentColumnType = computed(() => {
  if (currentTable.value && editingColumnIndex.value >= 0) {
    return currentTable.value.columnTypes[editingColumnIndex.value] || 'text';
  }
  return 'text';
});

// 左侧列表数据（直接使用接口返回的数据）
const tableListData = computed(() => {
  return tableList.value;
});

const activeTableRowKey = computed(() => {
  if (activeTableIndex.value < 0 || activeTableIndex.value >= tableList.value.length) return null;
  const item = tableList.value[activeTableIndex.value];
  return item?.Id ?? item?.id ?? null;
});

// 当前表格的ID（用于判断是否已保存）
const currentTableId = computed(() => {
  if (activeTableIndex.value < 0) return null;
  const item = tableList.value[activeTableIndex.value];
  return item?.Id || item?.id || null;
});

// 处理查看按钮点击（设置为查看模式）
const handleTableEdit = (row: any) => {
  isEditMode.value = false; // 设置为查看模式
  handleTableSelect(row);
};


// 进入编辑模式
const enterEditMode = () => {
  isEditMode.value = true;
  ElMessage.success('已进入编辑模式');
};

const buildSectionTitleList = (table: TableData): string[] => {
  const sectionTitles = [table.sectionNames[-1] || ''];
  table.horizontalHeaders.forEach((_, index) => {
    sectionTitles.push(table.sectionNames[index] || '');
  });
  return sectionTitles;
};

const buildPrintListDataFromTable = (table: TableData) => {
  const horizontalHeaders = table.horizontalHeaders.length > 0 ? table.horizontalHeaders : [''];
  const verticalHeaders = table.verticalHeaders.length > 0 ? table.verticalHeaders : [''];
  const sectionTitles = buildSectionTitleList(table);

  const subRows = verticalHeaders.map((header) => {
    const row: Record<string, string> = {
      Header: header || ''
    };
    horizontalHeaders.forEach((_, index) => {
      row[`_${index + 1}`] = '';
    });
    return row;
  });

  return [{
    方向: table.printOrientation === true,
    记录编号: '',
    设备编号: '',
    环境温度: '',
    校核: '',
    记录: '',
    检验: '',
    计算: '',
    检验日期: '',
    检测原始数据检测项目: {
      名称: table.name || '',
      受控编号: table.controlNumber || '',
      实施日期: table.implementDate || '',
      检测对象类型: table.detectionObjectType || '',
      是否计算: table.isCalculate ?? false,
      检测原始数据检测项目特殊属性集合: table.specialAttributes.map((attr) => ({
        标题: attr.title,
        内容: '',
        选项: attr.options || [],
        选项json: attr.options?.length ? JSON.stringify(attr.options) : ''
      })),
      检测原始数据检测数据格式描述: {
        横向标题: horizontalHeaders,
        分区线: table.columnBorders,
        分区标题: sectionTitles,
        分区标题JSON: JSON.stringify(sectionTitles),
        纵向标题: verticalHeaders,
        纵向标题JSON: JSON.stringify(verticalHeaders)
      },
      检测原始数据详细数据主表集合: [{
        层数: '',
        建筑名称: '',
        显示摘要: '',
        检测原始数据详细数据子表集合: subRows
      }]
    }
  }];
};

// 打印列表 - 使用本地构造的打印数据
const handlePrintList = () => {
  if (!currentTableId.value) {
    ElMessage.warning('请先保存表格后再预览');
    return;
  }

  if (!currentTable.value) {
    ElMessage.warning('表格数据未加载');
    return;
  }

  // 使用本地构造的数据
  const cacheKey = `table-definition-print-${String(currentTableId.value)}-${Date.now()}`;
  detailStore.setPrintListData(cacheKey, buildPrintListDataFromTable(currentTable.value));

  router.push({
    path: getMenuChildPathByComponent(
      '/ParameterSettings/tableEditing/index.vue',
      '打印列表',
      '/参数设置/检测项目定义/打印列表'
    ),
    query: {
      id: String(currentTableId.value),
      cacheKey
    }
  });
};

// 退出编辑模式
const exitEditMode = () => {
  ElMessageBox.confirm('确定要取消编辑吗？未保存的修改将丢失', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  }).then(() => {
    isEditMode.value = false;
    // 重新加载当前表格数据
    const currentItem = tableList.value[activeTableIndex.value];
    if (currentItem) {
      const itemId = currentItem.Id || currentItem.id;
      if (itemId) {
        handleTableSelect(currentItem);
      }
    }
    ElMessage.success('已退出编辑模式');
  }).catch(() => { /* cancelled */ });
};

// 处理删除按钮点击
const handleTableDelete = (row: any) => {
  const index = findTableIndex(row);
  if (index >= 0) deleteTable(index);
};


// 监听 tableListData 变化
watch(() => tableListData.value, () => {
  if (suppressTableListAutoSelect.value) return;
  // 数据更新时，如果当前选中的表格还存在，保持选中状态
  if (activeTableIndex.value >= 0 && activeTableIndex.value < tableList.value.length) {
    const currentItem = tableList.value[activeTableIndex.value];
    if (currentItem) {
      handleTableSelect(currentItem);
    }
  }
}, { deep: true, immediate: true });

// 加载表格列表数据（仅用于左侧列表展示）
const loadTableList = async () => {
  try {
    listLoading.value = true; // 开始加载
    // 构建分页参数
    const paginationData = {
      page: pagination.value.page,
      intPageSize: pagination.value.pageSize
    };
    // 将分页参数作为第二个参数，筛选参数作为第三个参数传递
    const res = await ParameterSettings.parameterSettingsListIndex(paginationData, filterParams.value);
    
    if (res && res.status === 200 && res.success && res.response && res.response.data) {
      // 直接使用接口返回的数据，不做复杂转换
      tableList.value = Array.isArray(res.response.data) ? res.response.data : [];
      // 更新总数 - 使用dataCount字段
      pagination.value.total = res.response.dataCount || res.response.total || res.response.count || 0;
      // 从接口返回中提取model数据
      if (res.response.model && typeof res.response.model === 'object') {
        tableModel.value = res.response.model;
      } else {
        tableModel.value = undefined;
      }
    } else {
      tableList.value = [];
      tableModel.value = undefined;
      pagination.value.total = 0;
    }
  } catch (error) {
    console.error('加载表格列表失败:', error);
    tableList.value = [];
    pagination.value.total = 0;
  } finally {
    listLoading.value = false; // 加载完成
  }
};

const loadDeviceTypeOptions = async () => {
  try {
    deviceTypeLoading.value = true;
    const res = await ParameterSettings.parameterSettingsDeviceTypeList(
      { page: 1, intPageSize: 50 },
      []
    );

    if (res && res.status === 200 && res.success && Array.isArray(res.response?.data)) {
      deviceTypeOptions.value = res.response.data
        .filter((item: any) => !item.ISDELETED && item.名称)
        .map((item: any) => ({
          名称: String(item.名称),
          提示词: item.提示词 || '',
          Id: item.Id
        }));
      if (currentTable.value && !currentTableId.value && !currentTable.value.deviceType) {
        currentTable.value.deviceType = getDefaultDeviceType();
      }
    } else {
      deviceTypeOptions.value = [];
    }
  } catch (error) {
    console.error('加载设备类型失败:', error);
    deviceTypeOptions.value = [];
  } finally {
    deviceTypeLoading.value = false;
  }
};

// 筛选处理函数（参考 OriginalDetectionList 的逻辑）
const handleFilter = (filters: any[]) => {
  console.log('筛选和排序参数:', filters);
  filterParams.value = filters;
  pagination.value.page = 1; // 筛选时重置到第一页
  loadTableList(); // 重新加载数据
};

// 分页器事件处理
const handlePageChange = (page: number) => {
  pagination.value.page = page;
  loadTableList();
};

const handlePageSizeChange = (pageSize: number) => {
  pagination.value.pageSize = pageSize;
  pagination.value.page = 1; // 改变页大小时重置到第一页
  loadTableList();
};

// 加载表格详情数据（用于右侧编辑区域）
const loadTableDetail = async (item: any) => {
  return parseTableDetail(item);
};

// 标记是否已完成首次加载
const isFirstLoad = ref(true);

// 组件挂载后加载数据
onMounted(async () => {
  await Promise.all([
    loadTableList(),
    loadDeviceTypeOptions()
  ]);
  isFirstLoad.value = false;
});

// 标签页切换回来时恢复选中状态（keep-alive 激活时触发）
onActivated(async () => {
  // 首次加载时 onMounted 已处理，跳过
  if (isFirstLoad.value) {
    return;
  }
  
  const savedId = pageStateStore.getSelectedId(route.path);
  if (savedId) {
    // 等待列表加载完成（如果正在加载）
    if (listLoading.value) {
      await new Promise<void>(resolve => {
        const unwatch = watch(listLoading, (loading) => {
          if (!loading) {
            unwatch();
            resolve();
          }
        });
      });
    }
    
    // 如果列表为空，重新加载
    if (tableList.value.length === 0) {
      await loadTableList();
    }
    
    // 在列表中查找对应的项目并加载详情
    const targetItem = tableList.value.find(item => 
      (item.Id || item.id) === savedId
    );
    if (targetItem) {
      await handleTableSelect(targetItem);
    }
  }
});

watch(() => currentTable.value?.name, (value) => {
  if (String(value || '').trim()) {
    showNameError.value = false;
  }
});

watch(() => currentTable.value?.controlNumber, (value) => {
  if (String(value || '').trim()) {
    showControlNumberError.value = false;
  }
});

watch(() => currentTable.value?.numberSuffix, (value) => {
  if (String(value || '').trim()) {
    showNumberSuffixError.value = false;
  }
});

watch(() => currentTable.value?.implementDate, (value) => {
  if (value) {
    showImplementDateError.value = false;
  }
});

// 添加新表格
const addNewTable = () => {
  clearRequiredFieldErrors();
  const tableName = `表格${tableList.value.length + 1}`;
  const newTable = createEmptyTable(tableName);
  newTable.deviceType = getDefaultDeviceType();
  
  // 创建列表项数据结构（用于左侧列表显示）
  const newListItem: any = {
    名称: tableName,
    编码: `TB${String(tableList.value.length + 1).padStart(4, '0')}`,
    _isNew: true,
    _tableData: newTable
  };
  
  tableList.value.push(newListItem);
  activeTableIndex.value = tableList.value.length - 1;
  currentTable.value = newTable;
  isEditMode.value = true;
  
  ElMessage.success('新增表格成功');
};

// 复制表格：完整复制表格结构与所有表单录入区域的值，生成一条新记录并进入编辑模式
const copyTable = async (row: any) => {
  clearRequiredFieldErrors();
  const index = findTableIndex(row);
  if (index < 0) return;

  const item = tableList.value[index];
  const itemId = item.Id || item.id;

  let sourceData: TableData | null = null;

  try {
    loading.value = true;
    if (item._isNew && item._tableData) {
      // 本地新增未保存的表格：直接复制内存数据
      sourceData = item._tableData;
    } else if (itemId) {
      // 已保存的表格：调用详情接口获取完整结构（含特殊属性）
      const res = await ParameterSettings.parameterSettingsById({ id: itemId });
      if (res && res.status === 200 && res.success && res.response) {
        sourceData = await loadTableDetail(res.response);
      } else {
        ElMessage.error('获取原记录数据失败');
        return;
      }
    } else {
      ElMessage.warning('该记录暂无可复制的数据');
      return;
    }

    if (!sourceData) {
      ElMessage.error('复制失败：未获取到数据');
      return;
    }

    // 深拷贝原记录，避免新记录与原记录共享引用
    const cloned = deepCloneTableData(sourceData);
    // 生成新记录名称（避免重名）
    cloned.name = generateCopyName(sourceData.name || item.名称 || item.name || '');
    // 清空原始数据ID：复制出来的是一条全新记录，保存时应走新增逻辑
    cloned.originalDataFormatDescId = undefined;

    const newListItem: any = {
      名称: cloned.name,
      编码: `TB${String(tableList.value.length + 1).padStart(4, '0')}`,
      _isNew: true,
      _tableData: cloned
    };

    tableList.value.push(newListItem);
    activeTableIndex.value = tableList.value.length - 1;
    currentTable.value = cloned;
    isEditMode.value = true;

    ElMessage.success(`已复制为「${cloned.name}」，请修改后保存`);
  } catch (error) {
    console.error('复制表格失败:', error);
    ElMessage.error('复制失败，请重试');
  } finally {
    loading.value = false;
  }
};

// 深拷贝表格数据（含嵌套的数组与对象）
const deepCloneTableData = (data: TableData): TableData => {
  try {
    return JSON.parse(JSON.stringify(data)) as TableData;
  } catch {
    return { ...data };
  }
};

// 生成副本名称：原名 + "副本"，若已存在则追加序号
const generateCopyName = (baseName: string): string => {
  const base = `${baseName || '表格'}副本`;
  const existingNames = new Set(
    tableList.value.map((item: any) => item.名称 || item.name || '')
  );
  if (!existingNames.has(base)) return base;
  let suffix = 2;
  while (existingNames.has(`${base}${suffix}`)) {
    suffix += 1;
  }
  return `${base}${suffix}`;
};

// 选择表格（通过ID加载详情数据）
const handleTableSelect = async (row: any) => {
  clearRequiredFieldErrors();
  const index = findTableIndex(row);
  
  if (index >= 0) {
    activeTableIndex.value = index;
    const item = tableList.value[index];
    
    // 保存当前选中的项目ID到store（用于标签页切换时恢复）
    const itemId = item.Id || item.id;
    if (itemId) {
      pageStateStore.setSelectedId(route.path, itemId);
    }
    
    // 如果是新添加的表格且有_tableData，直接使用
    if (item._isNew && item._tableData) {
      currentTable.value = item._tableData;
      return;
    }
    
    // 如果有ID，调用详情接口加载数据
    if (itemId) {
      try {
        loading.value = true; // 开始加载
        // 调用详情接口
        const res = await ParameterSettings.parameterSettingsById({ id: itemId });
        
        if (res && res.status === 200 && res.success && res.response) {
          // 使用 loadTableDetail 函数解析详情数据
          const tableData = await loadTableDetail(res.response);
          currentTable.value = tableData;
          ElMessage.success('数据加载成功');
        } else {
          ElMessage.error('数据加载失败');
          currentTable.value = createEmptyTable(item.名称 || item.name);
        }
      } catch (error) {
        console.error('加载表格详情失败:', error);
        ElMessage.error('数据加载失败');
        currentTable.value = createEmptyTable(item.名称 || item.name);
      } finally {
        loading.value = false; // 加载完成
      }
    } else {
      // 如果没有ID（可能是新增的表格），检查是否已有完整数据
      if (item.verticalHeaders && item.horizontalHeaders) {
        // 如果已有完整数据，直接使用
        currentTable.value = item as TableData;
      } else {
        currentTable.value = createEmptyTable(item.名称 || item.name);
      }
    }
  }
};

// 更新表格名称（如果接口数据中有 name 或 名称 字段）
const updateTableName = (index: number) => {
  const item = tableList.value[index];
  if (item) {
    const nameField = item.name || item.名称;
    if (nameField && typeof nameField === 'string' && !nameField.trim()) {
      item.name = item.名称 = `表格${index + 1}`;
    }
  }
};

// 删除表格
const deleteTable = async (index: number) => {
  const item = tableList.value[index];
  if (!item) return;

  const itemId = item.Id || item.id;
  
  // 如果是新建的表格（没有ID），直接从前端删除
  if (!itemId || item._isNew) {
    ElMessageBox.confirm('确定要删除这个表格吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      tableList.value.splice(index, 1);
      if (activeTableIndex.value === index) {
        activeTableIndex.value = -1;
        currentTable.value = null;
      }
      ElMessage.success('删除成功');
    }).catch(() => { /* cancelled */ });
    return;
  }

  // 有ID的情况，调用后端API删除
  ElMessageBox.confirm('确定要删除这个表格吗？删除后无法恢复', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  }).then(async () => {
    try {
      // 调用删除接口
      const res = await ParameterSettings.parameterSettingsDelete({ id: itemId });
      
      if (res && res.status === 200 && res.success) {
        const isDeletingActive = activeTableIndex.value === index;
        const activeItem = activeTableIndex.value >= 0 && activeTableIndex.value < tableList.value.length
          ? tableList.value[activeTableIndex.value]
          : null;
        const activeItemId = activeItem?.Id ?? activeItem?.id;

        // 如果删除的是当前选中的表格，清空选中状态
        if (isDeletingActive) {
          activeTableIndex.value = -1;
          currentTable.value = null;
          pageStateStore.clearSelectedId(route.path);
        } else if (activeTableIndex.value > index) {
          // 如果删除的项在当前选中项之前，需要调整索引
          activeTableIndex.value--;
        }
        
        if (tableList.value.length === 1 && pagination.value.page > 1) {
          pagination.value.page--;
        }
        suppressTableListAutoSelect.value = true;
        try {
          await loadTableList();
          if (!isDeletingActive && activeItemId) {
            const foundItem = findTableItem(activeItemId);
            if (foundItem) {
              await handleTableSelect(foundItem);
            }
          }
        } finally {
          suppressTableListAutoSelect.value = false;
        }
        ElMessage.success('删除成功');
      } else {
        ElMessage.error('删除失败');
      }
    } catch (error) {
      console.error('删除表格失败:', error);
      ElMessage.error('删除失败');
    }
  }).catch(() => { /* cancelled */ });
};

// 增加横向标题（列）
const addColumn = () => {
  if (!currentTable.value) return;
  const newColIndex = currentTable.value.horizontalHeaders.length;
  currentTable.value.horizontalHeaders.push(`列${newColIndex + 1}`);
  currentTable.value.columnTypes.push('number');
  currentTable.value.selectOptions.push([]);
  currentTable.value.autoFillRowCounts.push(0);
  currentTable.value.columnBorders.push(false);
  // sectionNames 是 Record<number, string>，新列默认没有分区名称，不需要添加
  // 为数据区域的每行添加空单元格
  currentTable.value.data.forEach(row => {
    row.push('');
  });
  ElMessage.success('增加横向标题成功'); 
};

// 删除横向标题（列）
const deleteColumn = (colIndex: number) => {
  if (!currentTable.value || currentTable.value.horizontalHeaders.length <= 1) {
    ElMessage.warning('至少保留一列');
    return;
  }
  currentTable.value.horizontalHeaders.splice(colIndex, 1);
  currentTable.value.columnTypes.splice(colIndex, 1);
  currentTable.value.selectOptions.splice(colIndex, 1);
  currentTable.value.autoFillRowCounts.splice(colIndex, 1);
  currentTable.value.columnBorders.splice(colIndex, 1);
  // 删除该列的分区名称，并重新映射后续列的索引
  delete currentTable.value.sectionNames[colIndex];
  const newSectionNames: Record<number, string> = {};
  if (currentTable.value.sectionNames[-1]) {
    newSectionNames[-1] = currentTable.value.sectionNames[-1];
  }
  Object.keys(currentTable.value.sectionNames).forEach(key => {
    const idx = Number(key);
    if (idx >= 0 && idx !== colIndex) {
      const newIdx = idx > colIndex ? idx - 1 : idx;
      if (currentTable.value!.sectionNames[idx]) {
        newSectionNames[newIdx] = currentTable.value!.sectionNames[idx];
      }
    }
  });
  currentTable.value.sectionNames = newSectionNames;
  currentTable.value.data.forEach(row => {
    row.splice(colIndex, 1);
  });
  ElMessage.success('删除横向标题成功');
};

// 更新横向标题
const updateColumnHeader = (colIndex: number, value: string) => {
  if (currentTable.value) {
    currentTable.value.horizontalHeaders[colIndex] = value;
  }
};

// 更新竖向标题
const updateVerticalHeader = (rowIndex: number, value: string) => {
  if (currentTable.value) {
    currentTable.value.verticalHeaders[rowIndex] = value;
  }
};

// 增加竖向标题（行）
const addRow = () => {
  if (!currentTable.value) return;
  currentTable.value.verticalHeaders.push(`行${currentTable.value.verticalHeaders.length + 1}`);
  // 为数据区域添加新行
  const newRow = new Array(currentTable.value.horizontalHeaders.length).fill('');
  currentTable.value.data.push(newRow);
  currentTable.value.columnTypes.forEach((type, colIndex) => {
    if (type === 'preset') {
      syncPresetColumn(colIndex);
    }
  });
  ElMessage.success('增加竖向标题成功');
};

// 删除竖向标题（行）
const deleteRow = (rowIndex: number) => {
  if (!currentTable.value || currentTable.value.verticalHeaders.length <= 1) {
    ElMessage.warning('至少保留一行');
    return;
  }
  currentTable.value.verticalHeaders.splice(rowIndex, 1);
  currentTable.value.data.splice(rowIndex, 1);
  currentTable.value.columnTypes.forEach((type, colIndex) => {
    if (type === 'preset') {
      syncPresetColumn(colIndex);
    }
  });
  ElMessage.success('删除竖向标题成功');
};

// 更新单元格
const updateCell = (rowIndex: number, colIndex: number, value: string) => {
  if (currentTable.value && currentTable.value.data[rowIndex]) {
    currentTable.value.data[rowIndex][colIndex] = value;
  }
};

// 清空表格
const clearTable = () => {
  ElMessageBox.confirm('确定要清空表格内容吗？', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  }).then(() => {
    if (currentTable.value) {
      const emptyTable = createEmptyTable(currentTable.value.name);
      Object.assign(currentTable.value, emptyTable);
    }
    ElMessage.success('清空成功');
  }).catch(() => { /* cancelled */ });
};

// 添加特殊属性（isSingle=true 为单条，false 为全局）
const addSpecialAttribute = (isSingle = false) => {
  if (!currentTable.value) return;
  currentTable.value.specialAttributes.push({ title: '', options: [], isSingle });
  ElMessage.success(isSingle ? '添加单条字段成功' : '添加全局字段成功');
};

// 删除特殊属性
const deleteSpecialAttribute = (index: number) => {
  if (!currentTable.value) return;
  currentTable.value.specialAttributes.splice(index, 1);
  ElMessage.success('删除特殊属性成功');
};

// 更新特殊属性标题
const updateSpecialAttribute = (index: number, value: string) => {
  if (currentTable.value) {
    currentTable.value.specialAttributes[index].title = value;
  }
};

// 切换属性作用域（全局 / 单条）
const toggleAttributeScope = (index: number) => {
  if (!currentTable.value) return;
  const attr = currentTable.value.specialAttributes[index];
  attr.isSingle = !attr.isSingle;
  ElMessage.success(attr.isSingle ? '已切换为单条字段' : '已切换为全局字段');
};

// 特殊属性选项弹框相关
const optionsDialogVisible = ref(false);
const currentOptionsIndex = ref(-1);
const currentOptions = ref<string[]>([]);

// 打开选项编辑弹框
const openOptionsDialog = (index: number) => {
  if (!currentTable.value) return;
  currentOptionsIndex.value = index;
  currentOptions.value = [...currentTable.value.specialAttributes[index].options];
  optionsDialogVisible.value = true;
};

// 添加选项
const addOption = () => {
  currentOptions.value.push('');
};

// 删除选项
const deleteOption = (index: number) => {
  currentOptions.value.splice(index, 1);
};

// 保存选项
const saveOptions = () => {
  if (!currentTable.value || currentOptionsIndex.value < 0) return;
  // 过滤空选项
  currentTable.value.specialAttributes[currentOptionsIndex.value].options = 
    currentOptions.value.filter(opt => opt.trim() !== '');
  optionsDialogVisible.value = false;
  ElMessage.success('选项保存成功');
};

// 特殊属性唯一ID映射（用于稳定的 key）
const specialAttrIdMap = ref<Map<number, string>>(new Map());
let specialAttrIdCounter = 0;

// 生成唯一ID
const generateAttrId = (): string => {
  return `attr_${++specialAttrIdCounter}_${Date.now()}`;
};

const globalAttributesWithId = computed<AttrWithId[]>(() => {
  if (!currentTable.value) return [];
  const attrs = currentTable.value.specialAttributes;
  const result: AttrWithId[] = [];
  attrs.forEach((attr, index) => {
    if (attr.isSingle === true) return;
    if (!specialAttrIdMap.value.has(index)) {
      specialAttrIdMap.value.set(index, generateAttrId());
    }
    result.push({
      id: specialAttrIdMap.value.get(index)!,
      originalIndex: index,
      title: attr.title,
      options: attr.options,
      isSingle: attr.isSingle
    });
  });
  return result;
});

// 单条属性列表（isSingle 为 true，右侧区域渲染）
const singleAttributesWithId = computed<AttrWithId[]>(() => {
  if (!currentTable.value) return [];
  const attrs = currentTable.value.specialAttributes;
  const result: AttrWithId[] = [];
  attrs.forEach((attr, index) => {
    if (attr.isSingle !== true) return;
    if (!specialAttrIdMap.value.has(index)) {
      specialAttrIdMap.value.set(index, generateAttrId());
    }
    result.push({
      id: specialAttrIdMap.value.get(index)!,
      originalIndex: index,
      title: attr.title,
      options: attr.options,
      isSingle: attr.isSingle
    });
  });
  return result;
});

// 特殊属性拖拽排序相关
const dragIndex = ref<number>(-1);
const dragOverIndex = ref<number>(-1);

const handleDragStart = (e: DragEvent, index: number) => {
  dragIndex.value = index;
  if (e.dataTransfer) {
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/plain', String(index));
  }
};

const handleDragEnd = () => {
  dragIndex.value = -1;
  dragOverIndex.value = -1;
};

const handleDragOver = (e: DragEvent, index: number) => {
  e.preventDefault();
  if (dragIndex.value !== -1 && dragIndex.value !== index) {
    dragOverIndex.value = index;
  }
};

const handleDragLeave = () => {
  dragOverIndex.value = -1;
};

const handleDrop = (e: DragEvent, targetIndex: number) => {
  e.preventDefault();
  if (!currentTable.value || dragIndex.value === -1 || dragIndex.value === targetIndex) {
    handleDragEnd();
    return;
  }

  const sourceIndex = dragIndex.value;
  const attrs = currentTable.value.specialAttributes;

  // 只允许同类型（全局/单条）内部排序，跨类型不处理
  const sourceIsSingle = attrs[sourceIndex].isSingle === true;
  const targetIsSingle = attrs[targetIndex].isSingle === true;
  if (sourceIsSingle !== targetIsSingle) {
    handleDragEnd();
    return;
  }

  // 同步移动 ID 映射
  const idMap = specialAttrIdMap.value;
  const sourceId = idMap.get(sourceIndex);
  const newIdMap = new Map<number, string>();

  // 移动元素
  const [movedItem] = attrs.splice(sourceIndex, 1);
  attrs.splice(targetIndex, 0, movedItem);

  // 重建 ID 映射，保持每个属性的 ID 不变
  attrs.forEach((_, index) => {
    if (index === targetIndex) {
      newIdMap.set(index, sourceId!);
    } else if (sourceIndex < targetIndex) {
      // 向后移动：sourceIndex 到 targetIndex-1 的元素向前移一位
      if (index >= sourceIndex && index < targetIndex) {
        newIdMap.set(index, idMap.get(index + 1)!);
      } else {
        newIdMap.set(index, idMap.get(index)!);
      }
    } else {
      // 向前移动：targetIndex+1 到 sourceIndex 的元素向后移一位
      if (index > targetIndex && index <= sourceIndex) {
        newIdMap.set(index, idMap.get(index - 1)!);
      } else {
        newIdMap.set(index, idMap.get(index)!);
      }
    }
  });

  specialAttrIdMap.value = newIdMap;

  handleDragEnd();
  ElMessage.success('排序已更新');
};

// 打开列类型设置对话框
const openColumnTypeDialog = (colIndex: number) => {
  editingColumnIndex.value = colIndex;
  editingAutoFillRows.value = Math.max(0, Number(currentTable.value?.autoFillRowCounts?.[colIndex]) || 0);
  showColumnTypeDialog.value = true;
};

// 确认设置列类型
const confirmColumnType = (type: ColumnType) => {
  if (currentTable.value && editingColumnIndex.value >= 0) {
    const colIndex = editingColumnIndex.value;
    const oldType = currentTable.value.columnTypes[colIndex];
    currentTable.value.columnTypes[colIndex] = type;
    if (!currentTable.value.autoFillRowCounts) currentTable.value.autoFillRowCounts = [];
    currentTable.value.autoFillRowCounts[colIndex] = Math.max(0, Number(editingAutoFillRows.value) || 0);
    
    // 下拉选择框与表格预设值列均需要配置选项。
    if (type === 'select' || type === 'preset') {
      if (type === 'preset') {
        if (oldType !== 'preset') {
          currentTable.value.selectOptions[colIndex] = currentTable.value.data.map(row => String(row[colIndex] || ''));
        }
      }
      showColumnTypeDialog.value = false;
      editingColumnIndex.value = -1;
      // 延迟打开选项编辑对话框，确保列类型设置对话框已关闭
      setTimeout(() => {
        openSelectOptionsDialog(colIndex);
      }, 100);
      return;
    }
    
    // 列类型发生变化时，清空该列所有单元格的值
    if (oldType !== type) {
      currentTable.value.data.forEach((row) => {
        row[colIndex] = '';
      });
    }
    
    ElMessage.success('设置成功');
  }
  showColumnTypeDialog.value = false;
  editingColumnIndex.value = -1;
};

// 取消设置列类型
const cancelColumnType = () => {
  showColumnTypeDialog.value = false;
  editingColumnIndex.value = -1;
};

// 打开下拉选项编辑对话框
const openSelectOptionsDialog = (colIndex: number) => {
  if (!currentTable.value) return;
  editingSelectOptionsColumnIndex.value = colIndex;
  const isPresetColumn = currentTable.value.columnTypes[colIndex] === 'preset';
  const currentOptions = currentTable.value.selectOptions[colIndex];
  if (isPresetColumn) {
    const rowCount = currentTable.value.verticalHeaders.length;
    editingSelectOptions.value = Array.from({ length: rowCount }, (_, rowIndex) => (
      String(currentOptions?.[rowIndex] ?? currentTable.value?.data[rowIndex]?.[colIndex] ?? '')
    ));
  } else {
    // 获取当前列的选项，如果没有则使用默认值
    const dialogOptions = currentOptions && currentOptions.length > 0
      ? [...currentOptions]
      : ['合格', '不合格', '待定'];
    editingSelectOptions.value = colIndex === 0 ? dialogOptions : stripSelectOptionImages(dialogOptions);
  }
  refreshSelectOptionThumbnails();
  showSelectOptionsDialog.value = true;
};

// 添加下拉选项
const addSelectOption = () => {
  editingSelectOptions.value.push('');
  setSelectOptionImageMeta(editingSelectOptions.value.length - 1, {});
};

// 删除下拉选项
const removeSelectOption = (index: number) => {
  if (editingSelectOptions.value.length > 1) {
    editingSelectOptions.value.splice(index, 1);
    refreshSelectOptionThumbnails();
  }
};

// 验证选项
const validateOption = (index: number) => {
  const { text, imageCode } = splitSelectOptionValue(editingSelectOptions.value[index] || '');
  const nextImageCode = canUploadSelectOptionImage.value ? imageCode : '';
  if (!text) {
    editingSelectOptions.value[index] = buildSelectOptionValue(`选项${index + 1}`, nextImageCode);
    return;
  }
  editingSelectOptions.value[index] = buildSelectOptionValue(text, nextImageCode);
};

// 确认保存下拉选项
const confirmSelectOptions = () => {
  if (!currentTable.value || editingSelectOptionsColumnIndex.value < 0) return;
  const colIndex = editingSelectOptionsColumnIndex.value;

  if (isPresetValueColumn.value) {
    const rowCount = currentTable.value.verticalHeaders.length;
    if (editingSelectOptions.value.length !== rowCount) {
      ElMessage.warning(`预设值数量必须与表格行数一致（当前共 ${rowCount} 行）`);
      return;
    }

    const presetValues = editingSelectOptions.value.map(value => String(value || '').trim());
    if (presetValues.some(value => !value)) {
      ElMessage.warning('请为每一行填写预设值');
      return;
    }

    currentTable.value.selectOptions[colIndex] = presetValues;
    syncPresetColumn(colIndex);
    ElMessage.success('表格预设值已保存');
    cancelSelectOptions();
    return;
  }
  
  // 过滤空选项并去除空格
  const validOptions = editingSelectOptions.value
    .map((opt, index) => {
      const { text, imageCode } = splitSelectOptionValue(opt);
      return buildSelectOptionValue(text || `选项${index + 1}`, canUploadSelectOptionImage.value ? imageCode : '');
    })
    .filter(opt => getSelectOptionText(opt) !== '');
  
  if (validOptions.length === 0) {
    ElMessage.warning('至少需要保留一个选项');
    return;
  }
  
  // 检查是否有重复选项，按选项文本去重，图片绑定随首次出现的选项保留
  const seenOptionTexts = new Set<string>();
  const uniqueOptions = validOptions.filter(option => {
    const optionText = getSelectOptionText(option);
    if (seenOptionTexts.has(optionText)) return false;
    seenOptionTexts.add(optionText);
    return true;
  });
  if (uniqueOptions.length !== validOptions.length) {
    ElMessage.warning('存在重复选项，已自动去重');
  }
  
  currentTable.value.selectOptions[colIndex] = uniqueOptions;
  ElMessage.success('保存成功');
  showSelectOptionsDialog.value = false;
  editingSelectOptionsColumnIndex.value = -1;
  editingSelectOptions.value = [];
  selectOptionImageMeta.value = {};
};

// 取消编辑下拉选项
const cancelSelectOptions = () => {
  showSelectOptionsDialog.value = false;
  editingSelectOptionsColumnIndex.value = -1;
  editingSelectOptions.value = [];
  selectOptionImageMeta.value = {};
  selectOptionPreviewUrl.value = '';
};

// 设置第一分区名称（从第一列开始的分区，不需要分界线）
// 使用 sectionNames[-1] 存储第一分区名称
const setFirstSectionName = async () => {
  if (!currentTable.value) return;
  
  const hasName = currentTable.value.sectionNames[-1];
  
  if (hasName) {
    // 取消分区名称
    delete currentTable.value.sectionNames[-1];
    ElMessage.success('已取消第一分区名称');
  } else {
    // 设置分区名称
    try {
      const { value } = await ElMessageBox.prompt('请输入第一分区名称', '设置分区名称', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: '例如：基本信息、检测数据',
        inputValue: ''
      });
      currentTable.value.sectionNames[-1] = value || '';
      nextTick(() => {
        setTimeout(updateSectionNames, 50);
      });
      ElMessage.success('已设置第一分区名称');
    } catch {
      // 用户取消
    }
  }
};

// 切换列边界线（不弹出分区名称对话框）
const toggleColumnBorderOnly = (colIndex: number) => {
  if (!currentTable.value) return;

  const isCurrentlySet = currentTable.value.columnBorders[colIndex];

  if (isCurrentlySet) {
    // 取消分界线
    currentTable.value.columnBorders[colIndex] = false;
    currentTable.value.sectionNames[colIndex] = '';
    ElMessage.success('已取消列边界线');
  } else {
    // 设置分界线，不设置分区名称
    currentTable.value.columnBorders[colIndex] = true;
    currentTable.value.sectionNames[colIndex] = '';
    ElMessage.success('已设置列边界线');
  }
};

// 切换列边界线
// columnBorders[colIndex] = 第 colIndex 列与第 colIndex+1 列之间的分界线
const toggleColumnBorder = async (colIndex: number) => {
  if (!currentTable.value) return;

  const isCurrentlySet = currentTable.value.columnBorders[colIndex];

  if (isCurrentlySet) {
    // 取消分界线
    currentTable.value.columnBorders[colIndex] = false;
    currentTable.value.sectionNames[colIndex] = '';
    ElMessage.success('已取消列边界线');
  } else {
    // 设置分界线，弹出对话框输入右侧分区名称
    try {
      const { value } = await ElMessageBox.prompt('请输入右侧分区名称', '设置分界线', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: '例如：基本信息、检测数据',
        inputValue: currentTable.value.sectionNames[colIndex] || ''
      });
      currentTable.value.columnBorders[colIndex] = true;
      currentTable.value.sectionNames[colIndex] = value || '';
      // 设置分界线后更新分区名称位置
      nextTick(() => {
        setTimeout(updateSectionNames, 50);
      });
      ElMessage.success('已设置列边界线');
    } catch {
      // 用户取消
    }
  }
};

// 处理列边界线右键点击 - 在指定位置插入新列
const handleColumnBorderRightClick = (event: MouseEvent, colIndex: number) => {
  event.preventDefault();
  if (!currentTable.value) return;
  
  ElMessageBox.confirm('确定要在此位置插入新列吗？', '插入列', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'info',
  }).then(() => {
    insertColumnAt(colIndex + 1);
  }).catch(() => { /* cancelled */ });
};

// 在指定位置插入新列
const insertColumnAt = (insertIndex: number) => {
  if (!currentTable.value) return;
  
  // 在横向标题中插入新列
  currentTable.value.horizontalHeaders.splice(insertIndex, 0, `列${insertIndex + 1}`);
  
  // 在列类型中插入默认类型
  currentTable.value.columnTypes.splice(insertIndex, 0, 'number');
  
  // 在列边界线中插入默认值
  currentTable.value.columnBorders.splice(insertIndex, 0, false);
  
  // 重新映射分区名称索引（插入位置及之后的索引都要+1）
  const newSectionNames: Record<number, string> = {};
  if (currentTable.value.sectionNames[-1]) {
    newSectionNames[-1] = currentTable.value.sectionNames[-1];
  }
  Object.keys(currentTable.value.sectionNames).forEach(key => {
    const idx = Number(key);
    if (idx >= 0) {
      const newIdx = idx >= insertIndex ? idx + 1 : idx;
      if (currentTable.value!.sectionNames[idx]) {
        newSectionNames[newIdx] = currentTable.value!.sectionNames[idx];
      }
    }
  });
  currentTable.value.sectionNames = newSectionNames;
  
  // 在下拉选项中插入空数组
  currentTable.value.selectOptions.splice(insertIndex, 0, []);
  currentTable.value.autoFillRowCounts.splice(insertIndex, 0, 0);
  
  // 在每一行数据中插入空单元格
  currentTable.value.data.forEach(row => {
    row.splice(insertIndex, 0, '');
  });
  
  ElMessage.success(`已在第 ${insertIndex + 1} 列位置插入新列`);
};

// 收集并格式化表格数据并保存
const saveTableData = async () => {
  if (!currentTable.value) {
    ElMessage.warning('请先选择或创建表格');
    return;
  }

  if (!validateRequiredFields()) {
    return;
  }

  const incompletePresetColumn = currentTable.value.columnTypes.findIndex((type, colIndex) => {
    if (type !== 'preset') return false;
    const presetOptions = currentTable.value!.selectOptions[colIndex] || [];
    return presetOptions.length !== currentTable.value!.verticalHeaders.length
      || presetOptions.some(value => !String(value || '').trim());
  });
  if (incompletePresetColumn >= 0) {
    ElMessage.warning(`请先完善“${currentTable.value.horizontalHeaders[incompletePresetColumn]}”列的表格预设值`);
    return;
  }

  const currentItem = activeTableIndex.value >= 0 && activeTableIndex.value < tableList.value.length
    ? tableList.value[activeTableIndex.value]
    : null;
  
  const itemId = currentItem?.Id || currentItem?.id;
  const isNew = currentItem?._isNew || !itemId;
  normalizeSelectOptionImages(currentTable.value);
  const submitData = formatTableDataForSave(currentTable.value, itemId, isNew);

  try {
    // 调用保存接口
    const res = await ParameterSettings.parameterSettingsSave(submitData);
    
    if (res && res.status === 200 && res.success) {
      if (isNew) {
        ElMessage.success('新增成功');
        // 新增成功后，获取返回的ID（后端返回格式：response.ID）
        const newId = res.response?.ID || res.response?.Id || res.response?.id;
        // 保存当前编辑的名称，用于刷新后重新定位
        const targetName = currentTable.value?.name;
        
        // 新增成功后刷新列表以获取最新的数据
        pagination.value.page = 1;
        suppressTableListAutoSelect.value = true;
        try {
          await loadTableList();
          // 刷新列表后，重新选中当前项（优先通过ID匹配，其次通过名称匹配）
          const foundItem = newId ? findTableItem(newId) : findTableItem(undefined, targetName);
          if (foundItem) {
            await handleTableSelect(foundItem);
          } else if (newId) {
            const detailRes = await ParameterSettings.parameterSettingsById({ id: newId });
            if (detailRes && detailRes.status === 200 && detailRes.success && detailRes.response) {
              currentTable.value = await loadTableDetail(detailRes.response);
              pageStateStore.setSelectedId(route.path, newId);
              activeTableIndex.value = -1;
            }
          }
        } finally {
          suppressTableListAutoSelect.value = false;
        }
        // 保存成功后退出编辑模式
        isEditMode.value = false;
      } else {
        ElMessage.success('更新成功');
        // 更新成功后，重新加载列表和当前项数据以获取最新数据
        await loadTableList();
        // 重新查找并选中当前项
        const foundItem = findTableItem(itemId, currentTable.value?.name);
        if (foundItem) {
          await handleTableSelect(foundItem);
          // 保存成功后退出编辑模式
          isEditMode.value = false;
        }
      }
    } else {
      ElMessage.error(isNew ? '新增失败' : '更新失败');
    }
  } catch (error: unknown) {
    console.error('保存表格数据失败:', error);
    // 拦截器已处理业务错误提示，这里不再重复提示
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, null, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "main-content",
          ref_key: "mainContentRef",
          ref: mainContentRef
        }, [
          _createElementVNode("div", {
            class: "left-panel",
            ref_key: "leftPanelRef",
            ref: leftPanelRef,
            style: _normalizeStyle({ width: leftPanelWidth.value + 'px' })
          }, [
            _createElementVNode("div", _hoisted_2, [
              (_unref(can)('新增'))
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "primary",
                    onClick: addNewTable
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Plus))
                        ]),
                        _: 1
                      }),
                      _cache[20] || (_cache[20] = _createTextVNode(" 新增 "))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_button, {
                type: "primary",
                circle: "",
                size: "small",
                class: "app-refresh-btn",
                onClick: loadTableList,
                loading: listLoading.value,
                icon: _unref(Refresh),
                style: {"margin-left":"auto"},
                title: "刷新"
              }, null, 8, ["loading", "icon"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(DynamicTable, {
                ref: "dynamicTableRef",
                data: tableListData.value,
                model: tableModel.value,
                loading: listLoading.value,
                "show-column-selector": false,
                "show-export": false,
                "show-edit-button": _unref(can)('查看'),
                "show-delete-button": _unref(can)('删除'),
                pagination: pagination.value,
                "active-row-key": activeTableRowKey.value,
                onEdit: handleTableEdit,
                onDelete: handleTableDelete,
                onFilter: handleFilter,
                onPageChange: handlePageChange,
                onPageSizeChange: handlePageSizeChange
              }, {
                action: _withCtx(({ row }) => [
                  _createVNode(_component_el_button, {
                    type: "success",
                    size: "small",
                    icon: _unref(CopyDocument),
                    plain: "",
                    title: "复制",
                    onClick: ($event: any) => (copyTable(row))
                  }, null, 8, ["icon", "onClick"])
                ]),
                _: 1
              }, 8, ["data", "model", "loading", "show-edit-button", "show-delete-button", "pagination", "active-row-key"])
            ])
          ], 4),
          _createElementVNode("div", {
            class: "resize-handle",
            onMousedown: startResize
          }, null, 32),
          _createElementVNode("div", _hoisted_4, [
            (currentTable.value)
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    (!isEditMode.value && _unref(can)('编辑'))
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "primary",
                          onClick: enterEditMode,
                          icon: _unref(Edit)
                        }, {
                          default: _withCtx(() => _cache[21] || (_cache[21] = [
                            _createTextVNode(" 编辑 ")
                          ])),
                          _: 1
                        }, 8, ["icon"]))
                      : _createCommentVNode("", true),
                    (isEditMode.value)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          type: "info",
                          onClick: exitEditMode,
                          icon: _unref(Close)
                        }, {
                          default: _withCtx(() => _cache[22] || (_cache[22] = [
                            _createTextVNode(" 取消编辑 ")
                          ])),
                          _: 1
                        }, 8, ["icon"]))
                      : _createCommentVNode("", true),
                    (currentTableId.value && !isEditMode.value && _unref(can)('打印'))
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 2,
                          type: "warning",
                          icon: _unref(Printer),
                          onClick: handlePrintList
                        }, {
                          default: _withCtx(() => _cache[23] || (_cache[23] = [
                            _createTextVNode(" 原始记录预览 ")
                          ])),
                          _: 1
                        }, 8, ["icon"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["form-item", { 'form-item--error': showNameError.value }])
                    }, [
                      _cache[24] || (_cache[24] = _createElementVNode("span", { class: "section-label section-label--required" }, "名称：", -1)),
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_el_input, {
                          modelValue: currentTable.value.name,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentTable.value.name) = $event)),
                          placeholder: "请输入表格名称",
                          readonly: !isEditMode.value
                        }, null, 8, ["modelValue", "readonly"]),
                        (showNameError.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, "请输入名称"))
                          : _createCommentVNode("", true)
                      ])
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["form-item", { 'form-item--error': showControlNumberError.value }])
                    }, [
                      _cache[25] || (_cache[25] = _createElementVNode("span", { class: "section-label section-label--required" }, "受控编号：", -1)),
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_el_input, {
                          modelValue: currentTable.value.controlNumber,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentTable.value.controlNumber) = $event)),
                          placeholder: "请输入受控编号",
                          readonly: !isEditMode.value
                        }, null, 8, ["modelValue", "readonly"]),
                        (showControlNumberError.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, "请输入受控编号"))
                          : _createCommentVNode("", true)
                      ])
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["form-item", { 'form-item--error': showNumberSuffixError.value }])
                    }, [
                      _cache[26] || (_cache[26] = _createElementVNode("span", { class: "section-label section-label--required" }, "编号后缀：", -1)),
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_el_input, {
                          modelValue: currentTable.value.numberSuffix,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currentTable.value.numberSuffix) = $event)),
                          placeholder: "请输入编号后缀",
                          readonly: !isEditMode.value
                        }, null, 8, ["modelValue", "readonly"]),
                        (showNumberSuffixError.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, "请输入编号后缀"))
                          : _createCommentVNode("", true)
                      ])
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["form-item form-item--date", { 'form-item--error': showImplementDateError.value }])
                    }, [
                      _cache[27] || (_cache[27] = _createElementVNode("span", { class: "section-label section-label--required" }, "实施日期：", -1)),
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_el_date_picker, {
                          modelValue: currentTable.value.implementDate,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((currentTable.value.implementDate) = $event)),
                          type: "date",
                          placeholder: "选择日期",
                          disabled: !isEditMode.value,
                          "value-format": "YYYY-MM-DD"
                        }, null, 8, ["modelValue", "disabled"]),
                        (showImplementDateError.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, "请选择实施日期"))
                          : _createCommentVNode("", true)
                      ])
                    ], 2),
                    _createElementVNode("div", _hoisted_16, [
                      _cache[28] || (_cache[28] = _createElementVNode("span", { class: "section-label" }, "数据类型：", -1)),
                      _createVNode(_component_el_select, {
                        modelValue: currentTable.value.type,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((currentTable.value.type) = $event)),
                        placeholder: "类型",
                        disabled: !isEditMode.value
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "表格",
                            value: "表格"
                          }),
                          _createVNode(_component_el_option, {
                            label: "图片",
                            value: "图片"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _cache[29] || (_cache[29] = _createElementVNode("span", { class: "section-label" }, "构件类型：", -1)),
                      _createVNode(_component_el_select, {
                        modelValue: currentTable.value.detectionObjectType,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((currentTable.value.detectionObjectType) = $event)),
                        placeholder: "类型",
                        disabled: !isEditMode.value,
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "默认",
                            value: "默认"
                          }),
                          _createVNode(_component_el_option, {
                            label: "墙",
                            value: "墙"
                          }),
                          _createVNode(_component_el_option, {
                            label: "板",
                            value: "板"
                          }),
                          _createVNode(_component_el_option, {
                            label: "梁",
                            value: "梁"
                          }),
                          _createVNode(_component_el_option, {
                            label: "柱",
                            value: "柱"
                          }),
                          _createVNode(_component_el_option, {
                            label: "地面",
                            value: "地面"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _cache[30] || (_cache[30] = _createElementVNode("span", { class: "section-label" }, "设备类型：", -1)),
                      _createVNode(_component_el_select, {
                        modelValue: currentTable.value.deviceType,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((currentTable.value.deviceType) = $event)),
                        placeholder: "请选择设备类型",
                        disabled: !isEditMode.value,
                        loading: deviceTypeLoading.value,
                        clearable: "",
                        filterable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deviceTypeOptions.value, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.Id,
                              label: item.名称,
                              value: item.名称
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled", "loading"])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _cache[31] || (_cache[31] = _createElementVNode("span", { class: "section-label" }, "是否计算：", -1)),
                      _createVNode(_component_el_switch, {
                        modelValue: currentTable.value.isCalculate,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((currentTable.value.isCalculate) = $event)),
                        disabled: !isEditMode.value,
                        "active-text": "是",
                        "inactive-text": "否"
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _cache[32] || (_cache[32] = _createElementVNode("span", { class: "section-label" }, "打印方向：", -1)),
                      _createVNode(_component_el_switch, {
                        modelValue: currentTable.value.printOrientation,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((currentTable.value.printOrientation) = $event)),
                        disabled: !isEditMode.value,
                        "active-text": "横向",
                        "inactive-text": "竖向"
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _cache[33] || (_cache[33] = _createElementVNode("span", { class: "section-label" }, "说明：", -1)),
                      _createVNode(_component_el_input, {
                        modelValue: currentTable.value.remark,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((currentTable.value.remark) = $event)),
                        type: "textarea",
                        autosize: { minRows: 3, maxRows: 6 },
                        placeholder: "请输入说明",
                        readonly: !isEditMode.value
                      }, null, 8, ["modelValue", "readonly"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _cache[46] || (_cache[46] = _createElementVNode("div", { class: "attributes-title" }, "非数据表区域字段配置", -1)),
                      _cache[47] || (_cache[47] = _createElementVNode("div", { class: "attributes-subtitle" }, "非数据表区域字段（即表格区域外需要录入的字段）", -1)),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Collection))
                              ]),
                              _: 1
                            }),
                            _cache[34] || (_cache[34] = _createElementVNode("span", null, "全局", -1))
                          ]),
                          _cache[39] || (_cache[39] = _createElementVNode("div", { class: "column-desc" }, "此原始记录所有数据公用的字段", -1)),
                          _createElementVNode("div", _hoisted_27, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(globalAttributesWithId.value, (attr) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: attr.id,
                                class: _normalizeClass(["attribute-item", { 'dragging': dragIndex.value === attr.originalIndex, 'drag-over': dragOverIndex.value === attr.originalIndex && dragIndex.value !== attr.originalIndex }]),
                                draggable: isEditMode.value,
                                onDragstart: ($event: any) => (handleDragStart($event, attr.originalIndex)),
                                onDragend: handleDragEnd,
                                onDragover: _withModifiers(($event: any) => (handleDragOver($event, attr.originalIndex)), ["prevent"]),
                                onDragleave: handleDragLeave,
                                onDrop: _withModifiers(($event: any) => (handleDrop($event, attr.originalIndex)), ["prevent"])
                              }, [
                                (isEditMode.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                      _createVNode(_component_el_icon, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(Rank))
                                        ]),
                                        _: 1
                                      })
                                    ]))
                                  : _createCommentVNode("", true),
                                _cache[37] || (_cache[37] = _createElementVNode("div", { class: "attribute-label" }, "字段：", -1)),
                                _createVNode(_component_el_input, {
                                  "model-value": attr.title,
                                  placeholder: "请输入标题",
                                  readonly: !isEditMode.value,
                                  "onUpdate:modelValue": (value) => updateSpecialAttribute(attr.originalIndex, value),
                                  class: "attribute-input",
                                  style: _normalizeStyle({ width: isEditMode.value ? '130px' : (attr.options.length > 0 ? '110px' : '170px') })
                                }, null, 8, ["model-value", "readonly", "onUpdate:modelValue", "style"]),
                                (!isEditMode.value && attr.options.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                      _cache[35] || (_cache[35] = _createElementVNode("span", { class: "options-label" }, "选项：", -1)),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attr.options, (opt, optIndex) => {
                                        return (_openBlock(), _createBlock(_component_el_tag, {
                                          key: optIndex,
                                          size: "small",
                                          type: "info",
                                          class: "option-tag"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(opt), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true),
                                (isEditMode.value)
                                  ? (_openBlock(), _createBlock(_component_el_button, {
                                      key: 2,
                                      type: "primary",
                                      size: "small",
                                      onClick: ($event: any) => (openOptionsDialog(attr.originalIndex)),
                                      class: "attribute-options-btn"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" 选项" + _toDisplayString(attr.options.length > 0 ? `(${attr.options.length})` : ''), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  : _createCommentVNode("", true),
                                (isEditMode.value)
                                  ? (_openBlock(), _createBlock(_component_el_button, {
                                      key: 3,
                                      type: "danger",
                                      size: "small",
                                      onClick: ($event: any) => (deleteSpecialAttribute(attr.originalIndex)),
                                      class: "attribute-delete-btn"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_icon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(Delete))
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  : _createCommentVNode("", true),
                                (isEditMode.value)
                                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                      key: 4,
                                      content: "切换为单条属性",
                                      placement: "top"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_button, {
                                          type: "info",
                                          size: "small",
                                          link: "",
                                          class: "attribute-switch-btn",
                                          onClick: ($event: any) => (toggleAttributeScope(attr.originalIndex))
                                        }, {
                                          default: _withCtx(() => _cache[36] || (_cache[36] = [
                                            _createTextVNode(" 单条→ ")
                                          ])),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true)
                              ], 42, _hoisted_28))
                            }), 128))
                          ]),
                          (isEditMode.value)
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                type: "primary",
                                plain: "",
                                size: "small",
                                onClick: _cache[10] || (_cache[10] = ($event: any) => (addSpecialAttribute(false))),
                                class: "add-attribute-btn"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(Plus))
                                    ]),
                                    _: 1
                                  }),
                                  _cache[38] || (_cache[38] = _createTextVNode(" 添加全局字段 "))
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(DocumentCopy))
                              ]),
                              _: 1
                            }),
                            _cache[40] || (_cache[40] = _createElementVNode("span", null, "单条", -1))
                          ]),
                          _cache[45] || (_cache[45] = _createElementVNode("div", { class: "column-desc" }, "此原始记录单次添加时需要录入的字段", -1)),
                          _createElementVNode("div", _hoisted_33, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(singleAttributesWithId.value, (attr) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: attr.id,
                                class: _normalizeClass(["attribute-item", { 'dragging': dragIndex.value === attr.originalIndex, 'drag-over': dragOverIndex.value === attr.originalIndex && dragIndex.value !== attr.originalIndex }]),
                                draggable: isEditMode.value,
                                onDragstart: ($event: any) => (handleDragStart($event, attr.originalIndex)),
                                onDragend: handleDragEnd,
                                onDragover: _withModifiers(($event: any) => (handleDragOver($event, attr.originalIndex)), ["prevent"]),
                                onDragleave: handleDragLeave,
                                onDrop: _withModifiers(($event: any) => (handleDrop($event, attr.originalIndex)), ["prevent"])
                              }, [
                                (isEditMode.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                      _createVNode(_component_el_icon, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(Rank))
                                        ]),
                                        _: 1
                                      })
                                    ]))
                                  : _createCommentVNode("", true),
                                _cache[43] || (_cache[43] = _createElementVNode("div", { class: "attribute-label" }, "字段：", -1)),
                                _createVNode(_component_el_input, {
                                  "model-value": attr.title,
                                  placeholder: "请输入标题",
                                  readonly: !isEditMode.value,
                                  "onUpdate:modelValue": (value) => updateSpecialAttribute(attr.originalIndex, value),
                                  class: "attribute-input",
                                  style: _normalizeStyle({ width: isEditMode.value ? '130px' : (attr.options.length > 0 ? '110px' : '170px') })
                                }, null, 8, ["model-value", "readonly", "onUpdate:modelValue", "style"]),
                                (!isEditMode.value && attr.options.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                      _cache[41] || (_cache[41] = _createElementVNode("span", { class: "options-label" }, "选项：", -1)),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attr.options, (opt, optIndex) => {
                                        return (_openBlock(), _createBlock(_component_el_tag, {
                                          key: optIndex,
                                          size: "small",
                                          type: "info",
                                          class: "option-tag"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(opt), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true),
                                (isEditMode.value)
                                  ? (_openBlock(), _createBlock(_component_el_button, {
                                      key: 2,
                                      type: "primary",
                                      size: "small",
                                      onClick: ($event: any) => (openOptionsDialog(attr.originalIndex)),
                                      class: "attribute-options-btn"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" 选项" + _toDisplayString(attr.options.length > 0 ? `(${attr.options.length})` : ''), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  : _createCommentVNode("", true),
                                (isEditMode.value)
                                  ? (_openBlock(), _createBlock(_component_el_button, {
                                      key: 3,
                                      type: "danger",
                                      size: "small",
                                      onClick: ($event: any) => (deleteSpecialAttribute(attr.originalIndex)),
                                      class: "attribute-delete-btn"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_icon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(Delete))
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  : _createCommentVNode("", true),
                                (isEditMode.value)
                                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                      key: 4,
                                      content: "切换为全局属性",
                                      placement: "top"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_button, {
                                          type: "info",
                                          size: "small",
                                          link: "",
                                          class: "attribute-switch-btn",
                                          onClick: ($event: any) => (toggleAttributeScope(attr.originalIndex))
                                        }, {
                                          default: _withCtx(() => _cache[42] || (_cache[42] = [
                                            _createTextVNode(" ←全局 ")
                                          ])),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true)
                              ], 42, _hoisted_34))
                            }), 128))
                          ]),
                          (isEditMode.value)
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                type: "primary",
                                plain: "",
                                size: "small",
                                onClick: _cache[11] || (_cache[11] = ($event: any) => (addSpecialAttribute(true))),
                                class: "add-attribute-btn"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(Plus))
                                    ]),
                                    _: 1
                                  }),
                                  _cache[44] || (_cache[44] = _createTextVNode(" 添加单条字段 "))
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _cache[51] || (_cache[51] = _createElementVNode("div", {
                        class: "attributes-title",
                        style: {"font-size":"14px","font-weight":"600","color":"#606266","margin-bottom":"10px"}
                      }, "示意图上传", -1)),
                      (imageUploading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                            _createVNode(_component_el_progress, {
                              type: "circle",
                              percentage: uploadProgress.value,
                              width: 80,
                              "stroke-width": 6
                            }, {
                              default: _withCtx(({ percentage }) => [
                                _createElementVNode("span", _hoisted_39, _toDisplayString(percentage) + "%", 1)
                              ]),
                              _: 1
                            }, 8, ["percentage"]),
                            _cache[48] || (_cache[48] = _createElementVNode("div", { class: "progress-label" }, "上传中...", -1))
                          ]))
                        : _createCommentVNode("", true),
                      (imageFileList.value.length === 0 && isEditMode.value && !imageUploading.value)
                        ? (_openBlock(), _createBlock(_component_el_upload, {
                            key: 1,
                            ref_key: "imageUploadRef",
                            ref: imageUploadRef,
                            class: "image-upload",
                            drag: "",
                            action: "#",
                            "http-request": handleImageUpload,
                            "file-list": imageFileList.value,
                            limit: 1,
                            "on-exceed": handleExceed,
                            "on-remove": handleImageRemove,
                            "on-preview": previewImage,
                            disabled: !isEditMode.value || imageUploading.value,
                            "show-file-list": false
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(UploadFilled))
                                ]),
                                _: 1
                              }),
                              _cache[49] || (_cache[49] = _createElementVNode("div", { class: "el-upload__text" }, [
                                _createTextVNode(" 拖拽文件到此处或 "),
                                _createElementVNode("em", null, "点击上传")
                              ], -1))
                            ]),
                            _: 1
                          }, 8, ["file-list", "disabled"]))
                        : _createCommentVNode("", true),
                      (imageFileList.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                            _createElementVNode("div", {
                              style: {"display":"flex","align-items":"center","cursor":"pointer","overflow":"hidden","flex":"1"},
                              onClick: _cache[12] || (_cache[12] = ($event: any) => (previewImage(imageFileList.value[0])))
                            }, [
                              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_41, [
                                ((imageFileList.value[0] as any).url)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: (imageFileList.value[0] as any).url,
                                      style: {"width":"100%","height":"100%","object-fit":"cover"},
                                      alt: "缩略图"
                                    }, null, 8, _hoisted_42))
                                  : (_openBlock(), _createBlock(_component_el_icon, {
                                      key: 1,
                                      style: {"font-size":"20px","color":"#909399"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(Document))
                                      ]),
                                      _: 1
                                    }))
                              ])), [
                                [_directive_loading, (imageFileList.value[0] as any).loading]
                              ]),
                              _createElementVNode("span", {
                                style: {"font-size":"14px","margin-right":"10px","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis","max-width":"150px"},
                                title: imageFileList.value[0].name
                              }, _toDisplayString(imageFileList.value[0].name), 9, _hoisted_43),
                              _createVNode(_component_el_tag, {
                                size: "small",
                                type: "success"
                              }, {
                                default: _withCtx(() => _cache[50] || (_cache[50] = [
                                  _createTextVNode("已上传")
                                ])),
                                _: 1
                              })
                            ]),
                            _createVNode(_component_el_button, {
                              type: "danger",
                              circle: "",
                              size: "small",
                              onClick: handleImageRemove,
                              disabled: !isEditMode.value
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(Delete))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _cache[58] || (_cache[58] = _createElementVNode("div", { class: "axis-placeholder-tip" }, "@@*表示占位符，系统自动取对应位置的轴线号", -1)),
                  (isEditMode.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                        (!currentTable.value.type || currentTable.value.type === '表格')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                              _createVNode(_component_el_button, {
                                type: "success",
                                onClick: addColumn,
                                size: "default"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(Plus))
                                    ]),
                                    _: 1
                                  }),
                                  _cache[52] || (_cache[52] = _createTextVNode(" 增加列 "))
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_button, {
                                type: "primary",
                                onClick: addRow,
                                size: "default"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(Plus))
                                    ]),
                                    _: 1
                                  }),
                                  _cache[53] || (_cache[53] = _createTextVNode(" 增加行 "))
                                ]),
                                _: 1
                              }),
                              _cache[54] || (_cache[54] = _createElementVNode("span", { class: "toolbar-tip" }, "提示：左键点击表头黑线可设置分界线，右键点击可插入新列", -1))
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_46, [
                          (_unref(can)('保存'))
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                type: "primary",
                                onClick: saveTableData
                              }, {
                                default: _withCtx(() => _cache[55] || (_cache[55] = [
                                  _createTextVNode("保存数据")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (!currentTable.value.type || currentTable.value.type === '表格')
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 1,
                                onClick: clearTable
                              }, {
                                default: _withCtx(() => _cache[56] || (_cache[56] = [
                                  _createTextVNode("清空表格")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!currentTable.value.type || currentTable.value.type === '表格')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                        _createElementVNode("div", _hoisted_48, [
                          (_openBlock(), _createElementBlock("div", {
                            class: "section-names-overlay",
                            key: `overlay-${sectionNameKey.value}`
                          }, [
                            (currentTable.value.sectionNames[-1])
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "section-name-label",
                                  style: _normalizeStyle(getFirstSectionNameStyle()),
                                  title: currentTable.value.sectionNames[-1]
                                }, " 分区名称：" + _toDisplayString(currentTable.value.sectionNames[-1]), 13, _hoisted_49))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentTable.value.horizontalHeaders, (header, colIndex) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: `section-${colIndex}-${sectionNameKey.value}`
                              }, [
                                (currentTable.value.columnBorders[colIndex] && currentTable.value.sectionNames[colIndex])
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: "section-name-label",
                                      style: _normalizeStyle(getSectionNameStyle(colIndex)),
                                      title: currentTable.value.sectionNames[colIndex]
                                    }, " 分区名称：" + _toDisplayString(currentTable.value.sectionNames[colIndex]), 13, _hoisted_50))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128))
                          ])),
                          _createElementVNode("table", {
                            class: "editable-table",
                            ref_key: "editableTableRef",
                            ref: editableTableRef
                          }, [
                            _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", {
                                  class: "corner-header",
                                  ref_key: "cornerHeaderRef",
                                  ref: cornerHeaderRef
                                }, [
                                  _cache[57] || (_cache[57] = _createTextVNode(" 标题 ")),
                                  (false && isEditMode.value && currentTable.value.horizontalHeaders.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        onClick: setFirstSectionName,
                                        onContextmenu: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (handleColumnBorderRightClick($event, -1)), ["prevent"])),
                                        class: _normalizeClass(['column-border-btn', 'first-column-border', { 'active': currentTable.value.sectionNames[-1] }]),
                                        title: "左键：设置第一分区名称 | 右键：插入新列"
                                      }, null, 34))
                                    : _createCommentVNode("", true)
                                ], 512),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentTable.value.horizontalHeaders, (header, colIndex) => {
                                  return (_openBlock(), _createElementBlock("th", {
                                    key: `header-${colIndex}`,
                                    ref_for: true,
                                    ref: (el) => setColumnHeaderRef(el as HTMLElement, colIndex),
                                    class: _normalizeClass(['table-header', { 'has-border': currentTable.value.columnBorders[colIndex] }])
                                  }, [
                                    _createVNode(_component_el_input, {
                                      "model-value": header,
                                      placeholder: "横向标题",
                                      readonly: !isEditMode.value,
                                      "onUpdate:modelValue": (value) => updateColumnHeader(colIndex, value),
                                      class: "header-input"
                                    }, null, 8, ["model-value", "readonly", "onUpdate:modelValue"]),
                                    (isEditMode.value && ['select', 'preset'].includes(currentTable.value.columnTypes[colIndex]))
                                      ? (_openBlock(), _createBlock(_component_el_button, {
                                          key: 0,
                                          type: "primary",
                                          size: "small",
                                          onClick: ($event: any) => (openSelectOptionsDialog(colIndex)),
                                          class: "select-options-btn",
                                          title: currentTable.value.columnTypes[colIndex] === 'preset' ? '编辑表格预设值' : (colIndex === 0 ? '编辑下拉选项，可绑定图片' : '编辑下拉选项（仅文字）')
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_icon, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(Edit))
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick", "title"]))
                                      : _createCommentVNode("", true),
                                    (isEditMode.value)
                                      ? (_openBlock(), _createBlock(_component_el_button, {
                                          key: 1,
                                          type: "info",
                                          size: "small",
                                          onClick: ($event: any) => (openColumnTypeDialog(colIndex)),
                                          class: "column-type-btn",
                                          title: "设置列类型"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_icon, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(Setting))
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]))
                                      : _createCommentVNode("", true),
                                    (isEditMode.value)
                                      ? (_openBlock(), _createBlock(_component_el_button, {
                                          key: 2,
                                          type: "danger",
                                          size: "small",
                                          onClick: ($event: any) => (deleteColumn(colIndex)),
                                          class: "delete-column-btn"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_icon, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(Delete))
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]))
                                      : _createCommentVNode("", true),
                                    (isEditMode.value && colIndex < currentTable.value.horizontalHeaders.length - 1)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 3,
                                          onClick: ($event: any) => (toggleColumnBorderOnly(colIndex)),
                                          onContextmenu: _withModifiers(($event: any) => (handleColumnBorderRightClick($event, colIndex)), ["prevent"]),
                                          class: _normalizeClass(['column-border-btn', { 'active': currentTable.value.columnBorders[colIndex] }]),
                                          title: "左键：设置分界线 | 右键：插入新列"
                                        }, null, 42, _hoisted_51))
                                      : _createCommentVNode("", true)
                                  ], 2))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentTable.value.verticalHeaders, (verticalHeader, rowIndex) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: `row-${rowIndex}`
                                }, [
                                  _createElementVNode("td", _hoisted_52, [
                                    _createVNode(_component_el_input, {
                                      "model-value": verticalHeader,
                                      placeholder: "竖向标题",
                                      readonly: !isEditMode.value,
                                      "onUpdate:modelValue": (value) => updateVerticalHeader(rowIndex, value),
                                      class: "vertical-header-input"
                                    }, null, 8, ["model-value", "readonly", "onUpdate:modelValue"])
                                  ]),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentTable.value.data[rowIndex], (cell, colIndex) => {
                                    return (_openBlock(), _createElementBlock("td", {
                                      key: `cell-${rowIndex}-${colIndex}`,
                                      class: _normalizeClass([
                        'data-cell',
                        {
                          'has-border': currentTable.value.columnBorders[colIndex],
                          'auto-fill-group-start': isAutoFillGroupStart(rowIndex, colIndex)
                        }
                      ])
                                    }, [
                                      (currentTable.value.columnTypes[colIndex] === 'text')
                                        ? (_openBlock(), _createBlock(_component_el_input, {
                                            key: 0,
                                            "model-value": cell,
                                            placeholder: "",
                                            readonly: ""
                                          }, null, 8, ["model-value"]))
                                        : (currentTable.value.columnTypes[colIndex] === 'number')
                                          ? (_openBlock(), _createBlock(_component_el_input_number, {
                                              key: 1,
                                              "model-value": Number(cell) || 0,
                                              placeholder: "",
                                              readonly: "",
                                              "controls-position": "right",
                                              style: {"width":"100%"}
                                            }, null, 8, ["model-value"]))
                                          : (currentTable.value.columnTypes[colIndex] === 'radio')
                                            ? (_openBlock(), _createBlock(_component_el_checkbox, {
                                                key: 2,
                                                "model-value": cell === '是' || cell === 'true' || cell === '1',
                                                readonly: "",
                                                class: "cell-checkbox"
                                              }, null, 8, ["model-value"]))
                                            : (currentTable.value.columnTypes[colIndex] === 'preset')
                                              ? (_openBlock(), _createBlock(_component_el_input, {
                                                  key: 3,
                                                  "model-value": cell,
                                                  readonly: "",
                                                  class: "preset-value-input"
                                                }, null, 8, ["model-value"]))
                                              : (currentTable.value.columnTypes[colIndex] === 'select')
                                                ? (_openBlock(), _createBlock(_component_el_select, {
                                                    key: 4,
                                                    "model-value": cell,
                                                    placeholder: "",
                                                    readonly: "",
                                                    style: {"width":"100%"}
                                                  }, {
                                                    default: _withCtx(() => [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((currentTable.value.selectOptions[colIndex] || []), (option, optionIndex) => {
                                                        return (_openBlock(), _createBlock(_component_el_option, {
                                                          key: optionIndex,
                                                          label: getSelectOptionText(option),
                                                          value: option
                                                        }, null, 8, ["label", "value"]))
                                                      }), 128))
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["model-value"]))
                                                : _createCommentVNode("", true)
                                    ], 2))
                                  }), 128)),
                                  (isEditMode.value)
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_53, [
                                        _createVNode(_component_el_button, {
                                          type: "danger",
                                          size: "small",
                                          onClick: ($event: any) => (deleteRow(rowIndex)),
                                          class: "delete-row-btn"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_icon, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(Delete))
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]))
                                    : (_openBlock(), _createElementBlock("td", _hoisted_54))
                                ]))
                              }), 128))
                            ])
                          ], 512)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])), [
                  [_directive_loading, loading.value]
                ])
              : (_openBlock(), _createElementBlock("div", _hoisted_55, [
                  _createVNode(_component_el_empty, { description: "请先创建或选择一个表格" })
                ]))
          ])
        ], 512)
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: showColumnTypeDialog.value,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((showColumnTypeDialog).value = $event)),
      title: "设置列类型",
      width: "760px",
      onClose: cancelColumnType
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, { onClick: cancelColumnType }, {
          default: _withCtx(() => _cache[61] || (_cache[61] = [
            _createTextVNode("取消")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_56, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columnTypeOptions, (option) => {
            return _createElementVNode("div", {
              key: option.value,
              class: _normalizeClass(['column-type-item', { 'active': currentColumnType.value === option.value }]),
              onClick: ($event: any) => (confirmColumnType(option.value as ColumnType))
            }, [
              _createElementVNode("div", _hoisted_58, [
                (option.value === 'text')
                  ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Edit))
                      ]),
                      _: 1
                    }))
                  : (option.value === 'number')
                    ? (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(DataAnalysis))
                        ]),
                        _: 1
                      }))
                    : (option.value === 'radio')
                      ? (_openBlock(), _createBlock(_component_el_icon, { key: 2 }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(CircleCheck))
                          ]),
                          _: 1
                        }))
                      : (option.value === 'select')
                        ? (_openBlock(), _createBlock(_component_el_icon, { key: 3 }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(ArrowDown))
                            ]),
                            _: 1
                          }))
                        : (option.value === 'preset')
                          ? (_openBlock(), _createBlock(_component_el_icon, { key: 4 }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CollectionTag))
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_59, _toDisplayString(option.label), 1),
              (currentColumnType.value === option.value)
                ? (_openBlock(), _createBlock(_component_el_icon, {
                    key: 0,
                    class: "check-icon"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Check))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ], 10, _hoisted_57)
          }), 64))
        ]),
        _createElementVNode("div", _hoisted_60, [
          _cache[59] || (_cache[59] = _createElementVNode("span", { class: "auto-fill-row-label" }, "自动填充行数", -1)),
          _createVNode(_component_el_select, {
            modelValue: editingAutoFillRows.value,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((editingAutoFillRows).value = $event)),
            size: "small",
            onChange: updateEditingAutoFillRows
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "不自动填充",
                value: 0
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(autoFillRowOptions.value, (count) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: count,
                  label: `${count} 行一组`,
                  value: count
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _cache[60] || (_cache[60] = _createElementVNode("span", { class: "auto-fill-row-help" }, "例如选择 3，表示每 3 行为一组，并显示横向分界线。", -1))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: showSelectOptionsDialog.value,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((showSelectOptionsDialog).value = $event)),
      title: selectOptionsDialogTitle.value,
      width: "760px",
      onClose: cancelSelectOptions
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, { onClick: cancelSelectOptions }, {
          default: _withCtx(() => _cache[66] || (_cache[66] = [
            _createTextVNode("取消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirmSelectOptions
        }, {
          default: _withCtx(() => _cache[67] || (_cache[67] = [
            _createTextVNode("确定")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_61, [
          (isPresetValueColumn.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_62, " 当前表格共 " + _toDisplayString(currentTable.value?.verticalHeaders.length || 0) + " 行，请为每一行设置对应的预设值。 自动填充行数是独立的列配置，不影响这里的预设值数量。 ", 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_63, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editingSelectOptions.value, (option, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "option-item"
              }, [
                _createElementVNode("div", _hoisted_64, [
                  _createVNode(_component_el_input, {
                    modelValue: editingSelectOptions.value[index],
                    "onUpdate:modelValue": ($event: any) => ((editingSelectOptions.value[index]) = $event),
                    placeholder: isPresetValueColumn.value ? `第 ${index + 1} 组预设值` : `选项 ${index + 1}`,
                    onBlur: ($event: any) => (validateOption(index))
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "onBlur"]),
                  (!isPresetValueColumn.value && canUploadSelectOptionImage.value && getSelectOptionImageCode(option))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                        _withDirectives((_openBlock(), _createElementBlock("div", {
                          class: "option-thumb",
                          onClick: ($event: any) => (previewSelectOptionImage(index))
                        }, [
                          (selectOptionImageMeta.value[index]?.thumbnailUrl)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: selectOptionImageMeta.value[index].thumbnailUrl,
                                alt: "选项图片"
                              }, null, 8, _hoisted_67))
                            : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Document))
                                ]),
                                _: 1
                              }))
                        ], 8, _hoisted_66)), [
                          [_directive_loading, selectOptionImageMeta.value[index]?.loading]
                        ]),
                        _createElementVNode("div", _hoisted_68, [
                          _createElementVNode("span", {
                            class: "option-image-name",
                            title: getSelectOptionImageCode(option)
                          }, _toDisplayString(getSelectOptionImageCode(option)), 9, _hoisted_69),
                          _createVNode(_component_el_tag, {
                            size: "small",
                            type: "success"
                          }, {
                            default: _withCtx(() => _cache[62] || (_cache[62] = [
                              _createTextVNode("已绑定")
                            ])),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (!isPresetValueColumn.value && canUploadSelectOptionImage.value)
                  ? (_openBlock(), _createBlock(_component_el_upload, {
                      key: 0,
                      class: "option-upload",
                      action: "#",
                      accept: "image/*",
                      "show-file-list": false,
                      "http-request": (uploadOptions) => handleSelectOptionImageUpload(uploadOptions, index),
                      disabled: selectOptionImageMeta.value[index]?.uploading
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          size: "small",
                          plain: "",
                          loading: selectOptionImageMeta.value[index]?.uploading
                        }, {
                          default: _withCtx(() => _cache[63] || (_cache[63] = [
                            _createTextVNode(" 上传图片 ")
                          ])),
                          _: 2
                        }, 1032, ["loading"])
                      ]),
                      _: 2
                    }, 1032, ["http-request", "disabled"]))
                  : _createCommentVNode("", true),
                (!isPresetValueColumn.value && canUploadSelectOptionImage.value && getSelectOptionImageCode(option))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      type: "warning",
                      size: "small",
                      plain: "",
                      onClick: ($event: any) => (clearSelectOptionImage(index))
                    }, {
                      default: _withCtx(() => _cache[64] || (_cache[64] = [
                        _createTextVNode(" 解绑 ")
                      ])),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                (!isPresetValueColumn.value)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 2,
                      type: "danger",
                      size: "small",
                      onClick: ($event: any) => (removeSelectOption(index)),
                      readonly: editingSelectOptions.value.length <= 1
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Delete))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick", "readonly"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          (!isPresetValueColumn.value)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                type: "primary",
                onClick: addSelectOption,
                class: "add-option-btn"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Plus))
                    ]),
                    _: 1
                  }),
                  _cache[65] || (_cache[65] = _createTextVNode(" 添加选项 "))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: selectOptionImagePreviewVisible.value,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((selectOptionImagePreviewVisible).value = $event)),
      title: "选项图片预览",
      width: "72%",
      top: "6vh",
      "append-to-body": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_70, [
          (selectOptionPreviewUrl.value)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: selectOptionPreviewUrl.value,
                alt: "选项图片预览"
              }, null, 8, _hoisted_71))
            : (_openBlock(), _createElementBlock("div", _hoisted_72, "图片加载中..."))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: optionsDialogVisible.value,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((optionsDialogVisible).value = $event)),
      title: "编辑特殊属性选项",
      width: "400px",
      "close-on-click-modal": false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[18] || (_cache[18] = ($event: any) => (optionsDialogVisible.value = false))
        }, {
          default: _withCtx(() => _cache[69] || (_cache[69] = [
            _createTextVNode("取消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: saveOptions
        }, {
          default: _withCtx(() => _cache[70] || (_cache[70] = [
            _createTextVNode("确定")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentOptions.value, (opt, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              style: {"display":"flex","align-items":"center","gap":"8px","margin-bottom":"10px"}
            }, [
              _createVNode(_component_el_input, {
                modelValue: currentOptions.value[index],
                "onUpdate:modelValue": ($event: any) => ((currentOptions.value[index]) = $event),
                placeholder: "请输入选项",
                style: {"flex":"1"}
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_el_button, {
                type: "danger",
                size: "small",
                onClick: ($event: any) => (deleteOption(index))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Delete))
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]))
          }), 128)),
          _createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            onClick: addOption,
            style: {"margin-top":"10px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_unref(Plus))
                ]),
                _: 1
              }),
              _cache[68] || (_cache[68] = _createTextVNode(" 添加选项 "))
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})